import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject, Subscription, forkJoin, fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { PhoneNumberFormat } from '@enums/phone-number-format.enum';
import { commonImages } from '@images/common-images';
import { contactImages } from '@images/contact-images';
import { ApiService } from '@services/api/api.service';
import { HistoryService } from '@services/api/history.service';
import { LeadsService } from '@services/api/leads.service';
import { ListingPropertiesService } from '@services/api/listing-properties.service';
import { SettingService } from '@services/api/setting.service';
import { SharedService } from '@services/api/shared.service';
import { StaffContactService } from '@services/api/staff-contact.service';
import { TagMangerService } from '@services/api/tag-manger.service';
import { TaskService } from '@services/api/task.service';
import { UserService } from '@services/api/user.service';
import { WorkflowService } from '@services/api/workflow.service';
import { AuthService } from '@services/auth.service';
import { AlertService } from '@services/helpers/alert.service';
import { Crypto } from '@services/helpers/encryption-utils';
import { FormHelper } from '@services/helpers/form-helper';
import { LocalStorageService } from '@services/helpers/local-storage.service';
import { Utils } from '@services/helpers/utils';
import { LeadManagementService } from '@services/lm-service/lead-management.service';
import { MessageService } from '@services/util/message.service';
import { RemmiConfirmService } from '@common/remmi-confirm/remmi-confirm.service';
import { RootReducerState, getLoggedInUserStatus } from '@state-management/reducers';
import { ReduxService } from '@state-management/redux.service';
import { DashService } from '../../dash-board/dash.service';
import { tabsConfig } from '../edit-office-contact/tabs.config';
import { ContactAlternativeRow, toAlternativePayload } from '../contact-alternative-info/contact-alternative-info.model';
import { OverlayPanel } from 'primeng/overlaypanel';
import moment from 'moment';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-add-office-contact',
  templateUrl: './add-office-contact.component.html',
  styleUrls: ['./add-office-contact.component.scss'],
})
export class AddOfficeContactComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @ViewChild('contactFormElement') formElementRef!: ElementRef;
  @ViewChild('searchKeyword', { static: true }) searchKeyword: ElementRef;
  @ViewChild('ops') ops!: OverlayPanel;
  @ViewChild('chipsRef', { read: ElementRef }) chipsRef: ElementRef;

  @Input() id: any;
  @Input() tabIndex: any;
  @Input() typed: any;
  @Input() company_typed: any;
  @Input() renderTaskList: any;
  @Input() IsLeadSaved: Observable<boolean> = null;
  @Input() IsProjectSaved: Observable<boolean> = null;
  @Input() renderPropertyList: Observable<boolean> = null;
  @Output() isPropertyOpen = new EventEmitter<boolean>();
  @Output() isNewContact = new EventEmitter<any>();
  @Output() isContactClose = new EventEmitter<any>();
  @Output() emitterObject = new EventEmitter<any>();
  @Output() NewLeadInformation = new EventEmitter<Object>();

  images = contactImages;
  common_images = commonImages;
  contactConflict: boolean = false;
  cContacts: any = [];
  showPassword: boolean = false;
  propertied: any;
  private searchStreams = new Subject<string>();
  public searchInput = new Subject<string>();
  AddNewProject: any[] = [];
  AssociatedProjectSelection: any[] = [];
  AssociatedProjectsUsers: any[] = [];
  showMenu: boolean = false;
  selectedItem: any;
  relatedContactTags: any[] = [];
  totalHistoryRecord;
  listingBtnDisable: boolean = true;
  companies = null;
  filterCompany: any[] = [];
  newCompany: boolean = false;
  full_company: any;
  attach_company: any[] = [];
  totalRecord;
  contact_search_complete: boolean = false;
  btnDisable: boolean = true;
  isAttachingContact: boolean = false;
  insertedUserId: any;
  contactType: any[] = [];
  preferred_contact_method: any[] = [];
  companyType: any[] = [];
  companyRole: any[] = [];
  addTile: any[] = [];
  addType: { tag_name: string; value: string }[] = [
    { tag_name: 'Company', value: 'Company' },
    { tag_name: 'Individual', value: 'Contact' },
  ];
  telephone_format: string = PhoneNumberFormat.International;
  mobile_format: string = PhoneNumberFormat.International;
  attached_properties: any[] = [];
  attached_listing: any[] = [];
  attached_contracts: any[] = [];
  attach_property: any;
  attach_listing: any;
  propertiesList: any;
  property_search_complete = false;
  email_modal: boolean = false;
  emailTo: string = '';
  emailFrom: string = 'remmi" <noreply@remmi.com.au>';
  emailTempSelectedId: any = null;
  emailTempSelected: any = null;
  emailTemplates: any;
  emailSubject: string = '';
  emailBody: string = '';
  rightActiveIndex: number = 0;
  selectedContact: any;
  public userPermission = Crypto.decrypt(this.localStorageService.GetItem('_per'));
  public userRole = Crypto.decrypt(this.localStorageService.GetItem('role'));
  public role_id: string = '';
  public selectedRows = [];
  public SortBy: string = '';
  logos = [];
  current_role_id: any;
  public Editor = ClassicEditor;
  AuthUser: any = null;
  accessRemmi: boolean = false;

  // -------------------------
  UserForm: FormGroup;
  public submitted: boolean = false;
  public loading: boolean = false;
  public error = null;
  public response: any;
  public randomstring: any;
  filteredItems = [];
  fullList: any[] = [];

  // related contacts variables
  attached_contacts: any = [];
  filteredContacts = [];
  full_attach_contact: any;
  attach_contact = null;
  queryParams: any = {};
  contact_to_update: String[] = [];
  disabled_tab: boolean = false;
  filteredListing: any;
  filteredProperty: any;
  property_Params: any = {};
  historyList: any[] = [];
  appointments: any[] = [];
  streams: any = [];
  stats: any = {
    totalleads: [],
  };
  keyword: string = '';
  history_keyword: string = '';
  addDefaults: any = {};
  isPrivate: boolean = false;
  isShowContactTask: boolean = true;
  privateSettings: any = null;
  contactTaskSettings: any = null;
  submittedBtn: boolean = false;

  // tags
  tagsData = [];
  tagsDataCopy = [];
  keywordTags: string = '';
  todo = [];

  // tag manager
  new_tag = [];
  tag_type = null;
  module_type = null;
  newTagTypePopUp: boolean = false;
  new_tag_popup: boolean = false;
  formAllFields: { name: string; label: string }[] = [];
  numOfNotValidFields: number = 0;
  requiredErrorMessages = [];
  notDisplayRequiredMessage: boolean = true;
  rPropActiveIndex: number = 1;
  dynamicPanelSizes: number[] = [50, 50];
  alternativeInfo: ContactAlternativeRow[] = [];
  selected_Contact_Input_id: any;
  isCache: boolean = true;
  private resizeSubscription: Subscription;
  isMobile: boolean;

  options = {
    types: [],
    componentRestrictions: { country: 'AU' },
  };
  ckEditorToolbar = {
    toolbar: {
      items: [
        'heading',
        '|',
        'fontfamily',
        'fontsize',
        'fontColor',
        'fontBackgroundColor',
        '|',
        'bold',
        'italic',
        'strikethrough',
        'subscript',
        'superscript',
        'code',
        '|',
        'link',
        'uploadImage',
        'blockQuote',
        'codeBlock',
        '|',
        'alignment',
        '|',
        'bulletedList',
        'numberedList',
        'todoList',
        'outdent',
        'indent',
        '|',
        'undo',
        'redo',
      ],
      shouldNotGroupWhenFull: true,
    },
  };
  ContactColumns = [
    {
      type: 'text',
      field: 'relation',
      column: 'Relation',
    },
    {
      type: 'text',
      field: 'full_name',
      column: 'Name',
    },
    {
      type: 'text',
      field: 'company_name',
      column: 'Company',
    },
    {
      type: 'text',
      field: 'mobile_no',
      column: 'Mobile',
    },
    {
      type: 'text',
      field: 'contact_type',
      column: 'Contact Type',
    },
    {
      type: 'text',
      field: 'telephone_no',
      column: 'Telephone',
    },
    {
      type: 'text',
      field: 'email',
      column: 'Email',
    },
  ];
  aus_phone = {
    code: '+61',
    flag: 'https://flagpedia.net/data/flags/mini/au.png',
    name: 'Australia',
  };

  // ------------------

  constructor(
    private _workflowService: WorkflowService,
    private redux: ReduxService,
    public lmService: LeadManagementService,
    private api: ApiService,
    private Auth: AuthService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private formHelper: FormHelper,
    private localStorageService: LocalStorageService,
    private alertService: AlertService,
    private store: Store<RootReducerState>,
    private dash: DashService,
    public sharedService: SharedService,
    public taskService: TaskService,
    public leads: LeadsService,
    public tagMangerService: TagMangerService,
    public listingService: ListingPropertiesService,
    public userService: UserService,
    private _staffContactService: StaffContactService,
    private _historyService: HistoryService,
    private message: MessageService,
    private _settingService: SettingService,
    private router: Router,
    private remmiConfirm: RemmiConfirmService
  ) {
    this.UserForm = this.fb.group({
      isPrivate: [false],
      type: ['Contact'],
      contact_type: ['Client'],
      add_title: [''],
      nick_name: [''],
      age: [''],
      company_type: [null],
      photo: [''],
      role_id: [''],
      office_id: [''],
      sub_office_id: [null],
      user_type: ['Contact'],
      username: [''],
      first_name: [''],
      last_name: [''],
      preferred_contact_method: [''],
      authentication_type: [''],
      mobile_no: [''],
      telephone_no: [''],
      website: [''],
      position: [null],
      wechat: [''],
      email: [''],
      password: [''],
      company: [''],
      parent_id: [''],
      // address
      building_name: [''],
      company_name: [''],
      unit_no: [''],
      street_no: [''],
      street_name: [''],
      suburb: [null],
      state: [''],
      post_code: [''],
      country: [''],

      gender: [''],
      birthday: [''],
      contact_listing_type: [''],

      contact_address: [''],
      tags: [[]],
    });
  }

  // Check if the @Input id value changes
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['id']?.currentValue?.length > 0 && changes?.['id']?.firstChange) {
      this.id = changes?.['id']?.currentValue;
      let isCache = this.localStorageService.GetItem('isCache');
      let cacheIds;
      if (isCache !== null && isCache !== undefined) {
        cacheIds = Crypto.decrypt(isCache);
        cacheIds.forEach((ele, idx) => {
          if (ele === this.id) {
            this.isCache = false;
            cacheIds.splice(idx, 1);
            this.localStorageService.SetItem('isCache', Crypto.encrypt(cacheIds));
          }
        });
      }
      this.selected_Contact_Input_id = changes?.['id']?.currentValue;
    }
  }
  // Component initialization calls
  ngOnInit(): void {
    this.findResponsive();
    this.selectedItem = tabsConfig[this.rightActiveIndex];
    // Subscribe to task list changes and refresh data accordingly
    this.renderTaskList?.subscribe({
      next: response => {
        if (response == true || response == false) {
          this.isCache = false;
          this.getTasks();
          this.getStream();
          this.message.getModuleHistory(true);
        }
      },
    });
    // Subscribe to property list changes and refresh data accordingly
    this.renderPropertyList?.subscribe({
      next: response => {
        if (response == true) {
          this.isCache = false;
          this.getProperties();
          this.getAttachedProperty();
        }
      },
    });
    // Reset new lead status
    this.lmService.is_new_lead = false;
    // Fetch logged-in user details
    this.store.pipe(select(getLoggedInUserStatus)).subscribe({
      next: user => {
        this.AuthUser = user?.data;
      },
    });
    // Set default office ID in user form
    this.UserForm.patchValue({
      office_id: this.api.getOfficeId(),
    });

    // Patch user form with predefined type and company type if available
    if (this.typed) {
      this.UserForm.patchValue({
        type: this.typed,
        company_type: this.company_typed,
      });
    }
    // Listen for office change events and refresh listings and properties
    this.Auth.getChangeUserOffice().subscribe({
      next: response => {
        if (response === 'change default office') {
          setTimeout(() => {
            this.getListing();
            this.getProperties();
          }, 500);
        }
      },
    });
    this.getTags();
    this.getListingTags();
    this.getSubOffices();

    // Reset tag manager flag
    this.lmService.tag_manager = false;
    // Listen for lead save events and refresh stream
    this.IsLeadSaved?.subscribe({
      next: () => {
        this.isCache = false;
        this.getStream();
      },
    });
    // Listen for project save events and refresh project list
    this.IsProjectSaved?.subscribe({
      next: () => {
        this.lmService.GetProjectList();
      },
    });
    // Implement debounce for search streams requests
    this.searchStreams.pipe(debounceTime(400), distinctUntilChanged()).subscribe({
      next: (searchTerm: string) => {
        this.getStream(this.streamPage, 15, searchTerm);
      },
    });

    this.searchInput.pipe(debounceTime(400), distinctUntilChanged()).subscribe({
      next: response => {
        this.lmService.getContactList(1, 30, response);
      },
    });
  }

  // Component After view lifecycle hook
  ngAfterViewInit(): void {
    fromEvent(this.searchKeyword.nativeElement, 'input')
      .pipe(map((event: Event) => (event.target as HTMLInputElement).value))
      .pipe(debounceTime(50))
      .pipe(distinctUntilChanged())
      .subscribe({ next: () => this.filterTags() });
  }
  // Component destroy lifecycle hook
  ngOnDestroy() {
    this.lmService.tag_manager = false;
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
  }

  findResponsive = () => {
    this.resizeSubscription = this.dash.screenSize$.subscribe({
      next: response => {
        if (response.width < 768) {
          this.isMobile = true;
          this.selectedItem = tabsConfig[this.rightActiveIndex];
        } else {
          this.isMobile = false;
        }
      },
    });
  };

  tabs = tabsConfig;
  isTabVisible(tab: any): boolean {
    if (!tab.conditions.length) return true;
    return tab.conditions.every((condition: any) => condition(this.userRole, this.userPermission));
  }

  getBadgeCount(tab: any): number {
    return tab.badge ? tab.badge({ ...this }) : null;
  }

  // Delete Profile Image
  delProfileImage() {
    if (this.lmService.contact_show_div == 'add_contact') {
      this.lmService.deleteImage(this.insertedUserId, this.UserForm.get('photo').value, 'users');
      this.UserForm.patchValue({
        photo: null,
      });
    } else {
      this.UserForm.patchValue({
        photo: null,
      });
    }
    // Clear the input value of the file, so that it can be re-selected
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
  // Get UserForm values
  get f() {
    return this.UserForm.controls;
  }

  subOfficeList: any[] = [];
  getSubOffices() {
    this._settingService.getSubOfficeList().subscribe({
      next: (response: any) => {
        this.subOfficeList = response?.data || [];
        this.applyDefaultSubOffice();
      },
    });
  }

  // Defaults the Sub Office field to the first option, same as the other office pickers.
  applyDefaultSubOffice() {
    if (!this._settingService.isSubOfficeAutoDefaultEnabled()) {
      return;
    }
    if (this.subOfficeList.length && !this.UserForm.get('sub_office_id')?.value) {
      this.UserForm.get('sub_office_id')?.setValue(this.subOfficeList[0]._id);
    }
  }
  // Adjust splitter horizontally
  onSplitterResize(e: any) {
    this.dynamicPanelSizes = [Math.round(e?.sizes[0]), Math.round(e?.sizes[1])];
  }
  openAddressOverlayPanel(event) {
    setTimeout(() => {
      this.ops.show(event);
    }, 0);
  }

  updateAddress() {
    // Construct the address string using form values
    let address = `${this.UserForm.get('building_name').value ? `"${this.UserForm.get('building_name').value}"` : ''} ${
      this.UserForm.get('unit_no').value ? this.UserForm.get('unit_no').value : ''
    } ${this.UserForm.get('street_no').value ? this.UserForm.get('street_no').value : ''} ${
      this.UserForm.get('street_name').value ? this.UserForm.get('street_name').value + ',' : ''
    } ${this.UserForm.get('suburb').value?.suburb ? this.UserForm.get('suburb').value?.suburb + ',' : ''} ${
      this.UserForm.get('state').value ? this.UserForm.get('state').value : ''
    } ${this.UserForm.get('post_code').value ? this.UserForm.get('post_code').value : ''}`;

    // If both unit number and street number are provided, format the address with a '/'
    if (this.UserForm?.get('unit_no')?.value?.trim() && this.UserForm?.get('street_no')?.value?.trim()) {
      let streetNoIndex = address.indexOf(this.UserForm?.get('street_no')?.value?.trim());

      // Insert '/' between unit number and street number
      address = address.substring(0, streetNoIndex - 1) + address.substring(streetNoIndex);
      address = [address.slice(0, streetNoIndex), '/', address.slice(streetNoIndex)].join('');
    }

    // Update the form field with the formatted address
    this.UserForm.patchValue({
      contact_address: address.trim(),
    });
  }

  // Get form's fields
  get first_name() {
    return this.UserForm.get('first_name');
  }

  get last_name() {
    return this.UserForm.get('last_name');
  }

  get company_name() {
    return this.UserForm.get('company_name');
  }

  // Set validations based on Contact Type
  contactTypeChanged() {
    if (this.UserForm.controls['type'].value === 'Company') {
      this.UserForm?.controls?.['company_name']?.setValidators([Validators.required]);
      this.UserForm?.controls?.['company_type']?.setValidators([Validators.required]);
      this.UserForm.controls['email'].setValidators([Validators.required, Validators.email]);
      this.UserForm?.controls?.['contact_type']?.setValidators([]);
      this.UserForm?.controls?.['mobile_no']?.setValidators([]);
      this.UserForm?.controls?.['first_name']?.setValidators([]);
      this.UserForm?.controls?.['last_name']?.setValidators([]);
      this.UserForm?.updateValueAndValidity();
    } else {
      this.UserForm.controls['first_name'].setValidators([Validators.required]);
      this.UserForm.controls['last_name'].setValidators([]);
      this.UserForm.controls['email'].setValidators([Validators.required, Validators.email]);
      this.UserForm?.controls?.['contact_type']?.setValidators([Validators.required]);
      this.UserForm?.controls?.['company_type']?.setValidators([]);
      this.UserForm?.controls?.['company_name']?.setValidators([]);
      this.UserForm?.controls?.['mobile_no']?.setValidators([]);
      this.UserForm?.updateValueAndValidity();
    }
  }

  // Create/Update Contact
  createContact(force, onlyUpdateOrCreate = '') {
    try {
      // Retrieve cached contacts from local storage
      let isCache = this.localStorageService.GetItem('isCache');
      if (isCache !== null && isCache !== undefined) {
        let cache = Crypto.decrypt(isCache);
        cache.push(this.id);
        this.localStorageService.SetItem('isCache', Crypto.encrypt(cache));
      } else {
        let cache = [];
        cache.push(this.id);
        this.localStorageService.SetItem('isCache', Crypto.encrypt(cache));
      }

      if (!this.UserForm.controls['contact_address'].value) {
        this.resetContactAddress();
      }
      // Set form submission state
      this.submitted = true;
      this.submittedBtn = true;
      this.lmService.tag_manager = false;
      // Patch form values
      this.UserForm.patchValue({ tags: this.todo });
      // Set validators based on the contact type (Company or Individual)
      if (this.UserForm.controls['type'].value === 'Company') {
        this.UserForm?.controls?.['company_name']?.setValidators([Validators.required]);
        this.UserForm.controls['email'].setValidators([Validators.required, Validators.email]);
        this.UserForm?.controls?.['mobile_no']?.setValidators([]);
        this.UserForm?.controls?.['first_name']?.setValidators([]);
        this.UserForm?.controls?.['last_name']?.setValidators([]);
      } else {
        this.UserForm.controls['first_name'].setValidators([Validators.required]);
        this.UserForm.controls['last_name'].setValidators([]);
        this.UserForm.controls['email'].setValidators([Validators.required, Validators.email]);
        this.UserForm?.controls?.['company_name']?.setValidators([]);
        this.UserForm?.controls?.['mobile_no']?.setValidators([]);
      }
      this.UserForm?.updateValueAndValidity();
      // Set username based on email
      this.UserForm.patchValue({ username: this.UserForm.get('email').value });
      // Adjust values for Company type
      if (this.UserForm.controls['type'].value === 'Company') {
        this.UserForm.patchValue({
          first_name: this.UserForm.controls['company_name'].value,
          contact_type: 'Company',
        });
      }
      // Validate form fields
      this.formHelper.validateAllFormFields(this.UserForm);
      if (!this.UserForm.valid) {
        let fields: any = Object.entries(this.UserForm.controls)
          .reduce((acc, [key, value]) => {
            if (value.status === 'INVALID') {
              acc.push(this.formAllFields.find(errorfield => errorfield.name === key) || undefined);
            }
            return acc;
          }, [])
          ?.filter(error_field => error_field !== undefined && error_field !== null);

        fields && this.validateFieldsOnRequest(fields);
        this.submittedBtn = false;
        return;
      }
      // Handle new contact creation
      if (this.lmService.contact_show_div == 'add_contact') {
        this.disabled_tab = true;
        if (!this.insertedUserId) {
          let form_data = this.UserForm.value;
          form_data['panel_size'] = this.dynamicPanelSizes;
          Object.assign(form_data, toAlternativePayload(this.alternativeInfo));
          form_data['isPrimaryAlias'] = true;
          form_data['is_new'] = true;
          form_data['password'] = this.randomstring;
          form_data['mobile_no'] = this.UserForm.controls['mobile_no'].value;

          if (this.logos?.length) {
            form_data['logos'] = this.logos;
          }
          this.loading = true;
          this.contactConflict = false;
          // API call to create contact
          this.userService.createContact({ ...form_data, force }).subscribe({
            next: response => {
              let url = `/contacts-filter?office_id=${this.api.getOfficeId()}&module_type=contact`;
              this.redux.getSetContactInfo(false, 'contacts-filter', url).subscribe();
              if (response?.insertedId) {
                this.insertedUserId = response?.insertedId;
                this.id = this.insertedUserId;
                this.selectedContact = this.selectedContact || {}; // Ensure it’s an object
                this.selectedContact['email'] = this.UserForm.get('email').value;
              }
              // Handle existing contact conflict
              if (response.hasOwnProperty('usersexist')) {
                this.contactConflict = true;
                this.cContacts = response.usersexist;
                this.submitted = false;
                this.submittedBtn = false;
                this.loading = false;
                this.toastr.warning('Contact exists with similar details');
                return;
              }
              this.submitted = false;
              this.submittedBtn = false;
              this.loading = false;
              this.toastr.success(this.UserForm.controls['type'].value === 'Company' ? 'Company has been created' : 'Contact has been created');
              this.disabled_tab = false;
              this.UserForm.patchValue({
                role_id: this.current_role_id,
                office_id: this.api.getOfficeId(),
                user_type: 'Contact',
              });
              // Update UI elements
              this.lmService.tab_levels?.forEach(el => {
                if (el.name.includes('Contact') && el.data == null) {
                  el.name = el?.name + ' - ' + this.UserForm.controls['first_name'].value + ' ' + this.UserForm.controls['last_name'].value;
                }
              });
              if (onlyUpdateOrCreate !== 'onlyCreate' && !this.contactConflict) {
                let tab = this.lmService.tab_levels.find(el => el.name.includes('Contact') && el.data == null);
                if (tab) {
                  let ind = this.lmService.tab_levels.indexOf(tab);
                  this.UserForm.reset();
                  this.isContactClose.emit({ level: tab, index: ind, id: this.insertedUserId });
                  this.isNewContact.emit(true);
                }
              }
              this.emitterObject.emit({ onlyUpdateOrCreate, id: this.insertedUserId });
              this.isPropertyOpen.emit(true);
              this.lmService.agencyListUpdated$.next();
              this.numOfNotValidFields = this.requiredErrorMessages.length = 0;

              // Fetch stream data
              this.getStream();
            },
            error: error => {
              this.submittedBtn = false;
              this.loading = false;
              let { fields, all_fields } = error?.error;
              if (fields?.length > 0) {
                this.formAllFields = fields.map(error_field => {
                  let isExistsField = all_fields?.find(field => field.name === error_field);
                  return isExistsField ? { name: error_field, label: isExistsField?.label || '' } : error_field;
                });
                this.toastr.error('Required fields must be filled in');
                this.validateFieldsOnRequest(fields);
              } else {
                let errorMessage = error?.error?.message ? error?.error?.message : error?.message;
                this.alertService.error(errorMessage);
              }
            },
          });
        } else {
          // Update existing contact
          delete this.UserForm.value['office_id'];
          delete this.UserForm.value['role_id'];
          delete this.UserForm.value['user_type'];
          delete this.UserForm.value['isPrivate'];
          if (this.UserForm.value['photo'] == this.selectedContact?.photo) {
            delete this.UserForm.value['photo'];
          }
          this.loading = true;
          let form_data = this.UserForm.value;
          if (this.logos?.length) {
            form_data['logos'] = this.logos.filter(img => !img.hasOwnProperty('_id'));
          }
          Object.assign(form_data, toAlternativePayload(this.alternativeInfo));
          form_data['mobile_no'] = this.UserForm.controls['mobile_no'].value;
          // API call to update contact
          this.userService.updateContact(this.insertedUserId, this.UserForm.value).subscribe({
            next: () => {
              this.submittedBtn = false;
              this.loading = false;
              this.toastr.success('Contact has been updated');
              this.message.getModuleHistory(true);
              if (onlyUpdateOrCreate !== 'onlyCreate' && !this.contactConflict) {
                let tab = this.lmService.tab_levels.find(el => el.name.includes('Contact') && el.data == null);
                if (tab) {
                  let ind = this.lmService.tab_levels.indexOf(tab);
                  this.UserForm.reset();
                  this.isContactClose.emit({ level: tab, index: ind, id: this.insertedUserId });
                  this.isNewContact.emit(true);
                }
              }
              this.emitterObject.emit({ onlyUpdateOrCreate, id: this.insertedUserId });
              this.isPropertyOpen.emit(true);
              this.lmService.agencyListUpdated$.next();
            },
            error: error => {
              this.submittedBtn = false;
              this.loading = false;
              this.toastr.error(error.message);
            },
          });
        }
      }
    } catch (error) {}
  }

  onSelectFile(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length) {
      const file = target.files[0];
      // Step 1: Check for allowed formats
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      if (!allowedTypes.includes(file.type)) {
        this.toastr.error('Unsupported file format! Please upload valid image');
        target.value = ''; // Reset the file input
        return;
      }

      // Step 2: Read file if valid
      const fileReader: FileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        this.UserForm.patchValue({
          photo: fileReader.result,
        });
        this.updateProfileOnImageChange();
      };
    }
  }

  // Auto generate password
  public generatePassword() {
    this.randomstring = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }

  // Fetch Suburb Data from API
  filterItems(event) {
    let query = event.query;
    this.sharedService.searchSuburb(query).subscribe({
      next: response => {
        this.filteredItems = [];
        this.filteredItems = response?.data;
      },
    });
  }

  // Patch data in Contact's Edit form
  patchEditForm() {
    this.isCache = false;
    let id = this.id ? this.id : this.insertedUserId;
    if (id) {
      this.userService.getContactUser(id).subscribe({
        next: response => {
          this.dynamicPanelSizes = response['data']?.panel_size ? response['data']?.panel_size : [50, 50];
          this.selectedContact = response?.data;
          if (this.GetAssociatedProjectEligibleStatus()) {
            this.GetAssociatedProjects();
          }
          this.emailTo = this.selectedContact.email;
          this.isCache = false;
          // condition of ownership and editor
          if (this.selectedContact?.user_id !== this.AuthUser?._id && this.AuthUser?.role !== 'Master Admin') {
            if (this.selectedContact?.isPrivate === true) {
              if (
                (this.selectedContact?.owners && this.selectedContact?.owners.includes(this.api.getUserId())) ||
                (this.privateSettings && this.privateSettings.viewRoles.includes(this.api.getRoleId())) ||
                this.selectedContact?.editors?.includes(this.api.getUserId())
              ) {
                this.isPrivate = false;
                this.UserForm.get('mobile_no').enable();
                this.UserForm.get('telephone_no').enable();
              } else {
                this.isPrivate = true;
                this.UserForm.get('mobile_no').disable();
                this.UserForm.get('telephone_no').disable();
              }
            } else {
              if (
                (this.privateSettings && this.privateSettings.viewRoles.includes(this.api.getRoleId())) ||
                this.selectedContact?.editors?.includes(this.api.getUserId())
              ) {
                this.isPrivate = false;
                this.UserForm.get('mobile_no').enable();
                this.UserForm.get('telephone_no').enable();
              } else {
                this.isPrivate = true;
                this.UserForm.get('mobile_no').disable();
                this.UserForm.get('telephone_no').disable();
              }
            }
          } else {
            this.isPrivate = false;
            this.UserForm.get('mobile_no').enable();
            this.UserForm.get('telephone_no').enable();
          }
          this.message.getModuleHistory(true);
          this.logos = this.selectedContact?.logos?.data;
          Object.keys(this.UserForm.controls).forEach(key => {
            if (key !== 'logos' && key !== 'tags' && key !== 'preferred_contact_method') {
              this.UserForm.controls[key].setValue(this.selectedContact[key] === null ? null : this.selectedContact[key]);
            } else if (key == 'logos') {
              this.UserForm.controls[key].setValue(this.selectedContact[key] === null ? null : this.selectedContact?.logos?.data);
            } else if (key == 'tags') {
              this.UserForm.controls[key].setValue(this.selectedContact[key] === null ? [] : this.selectedContact[key]);
              this.todo = this.selectedContact[key];
              if (this.todo == undefined || this.todo == null) {
                this.todo = [];
              }
            } else if (key == 'preferred_contact_method') {
              if (Array.isArray(this.selectedContact[key])) {
                this.UserForm.controls[key].setValue(this.selectedContact[key] === null ? null : this.selectedContact[key]);
              } else {
                this.UserForm.controls[key].setValue('');
              }
            }
          });
          if (!this.selectedContact?.telephone_no?.includes('+')) {
            this.telephone_format = PhoneNumberFormat.National;
          } else {
            this.telephone_format = PhoneNumberFormat.International;
          }
          if (!this.selectedContact?.mobile_no?.includes('+')) {
            this.mobile_format = PhoneNumberFormat.National;
          } else {
            this.mobile_format = PhoneNumberFormat.International;
          }
        },
      });
    }
  }
  selectCompany(e) {
    this.full_company = e;
    this.companies = `${e?.name}`;
    this.queryParams.contact_id = this.id;
    this.queryParams.related_contact_id = e?._id;
  }

  // Attaches a company to the contact, ensuring the company isn't already attached
  attachCompany() {
    let contact_id = this.id ? this.id : this.insertedUserId; // Determine the contact ID (either 'id' or 'insertedUserId')
    if (contact_id) {
      this.loading = true; // Set loading state to true
      if (!this.full_company) {
        this.loading = false; // Set loading state to false
        this.toastr.error('Please select company first'); // Show error if no company is selected
        return;
      } else {
        // Check if the company is already attached to the contact
        let findContact = this.attach_company?.find(item => item?.contact?._id == this.full_company?._id);
        if (findContact) {
          this.toastr.error('Company is already associate to this Contact'); // Show error if company is already attached
          this.loading = false; // Set loading state to false
          return;
        } else {
          this.queryParams.relation = []; // Reset the relation field
          // Make a POST request to attach the company to the contact
          this.api
            .post('/contacts/add-into-company', {
              contact_id: this.queryParams.contact_id ? this.queryParams.contact_id : this.insertedUserId, // Contact ID
              company_id: this.queryParams.related_contact_id, // Company ID
              relation: [], // Empty relation array
            })
            .subscribe({
              next: () => {
                this.companies = null; // Clear the companies field
                this.full_company = null; // Clear the full company field
                this.loading = false; // Set loading state to false
                this.isCache = false; // Reset cache flag
                this.queryParams = {}; // Clear query parameters
                this.toastr.success('Company added successfully'); // Show success message
                this.getCompany(); // Refresh the company list
                // Let hosts (e.g. the Lead form's Agent dropdown) know this contact is ready to
                // select — same signal a plain Save sends. Not a global isClearItems broadcast:
                // that used to also blank every other re-multiselect on the page (including the
                // Lead's own Agency/Agent dropdowns), since that message bus isn't scoped to this
                // component instance.
                this.emitterObject.emit({ onlyUpdateOrCreate: 'onlyCreate', id: contact_id });
              },
              error: error => {
                let message = error?.message || error?.error?.message;
                this.toastr.error(message); // Show error message if API request fails
                this.loading = false; // Set loading state to false
              },
            });
        }
      }
    } else {
      this.toastr.error('First create contact'); // Show error if no contact is created yet
    }
  }

  // Fetches and attaches companies related to the contact
  getCompany() {
    this.attach_company = []; // Clear the previous list of attached companies
    let getAttachContact = this.id ? this.id : this.insertedUserId; // Determine the contact ID to use (either 'id' or 'insertedUserId')
    if (getAttachContact) {
      // Make an API call to get the companies attached to the contact
      this.userService.getContactCampaigns(getAttachContact).subscribe({
        next: response => {
          this.isCache = true; // Set cache flag to true
          this.attach_company = response?.data; // Store the returned companies in 'attach_company'
        },
      });
    }
  }

  deleteCompany(id, companyName?: string) {
    this.remmiConfirm
      .delete({
        title: 'Remove Company?',
        message: 'This company will be unlinked from this contact.',
        subject: companyName,
        confirmLabel: 'Remove',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this.deleteCompanyNow(id);
        }
      });
  }

  private deleteCompanyNow(id) {
    let payload = {
      contact_id: this.id ? this.id : this.insertedUserId,
      company_id: id,
    };
    this.userService.deleteContactCompany(payload).subscribe({
      next: () => {
        this.getCompany();
        this.toastr.success('Deleted successfully');
      },
    });
  }

  // Open edit Form of different modules.
  openRightModal(contact, addOrEdit) {
    if (addOrEdit == 'edit_listing_property') {
      this.lmService.listing_show_div = addOrEdit;
      this.lmService.contact_showRightBar = true;
      this.lmService.addTabInLevels('Listing' + ' - ' + contact?.property_address, contact?._id);
      this.isPropertyOpen.emit(true);
      this.lmService.is_new_listing = false;
      this.lmService.prop_reload_rightBar = false;
      this.lmService.propIdForRightBar = contact?._id;
      setTimeout(() => {
        this.lmService.contact_showRightBar = true;
        this.lmService.prop_reload_rightBar = true;
      }, 500);
    } else if (addOrEdit === 'add_contract') {
      setTimeout(() => {
        this.lmService.contract_show_div = addOrEdit;
        this.lmService.addTabInLevels('Contract', 'createnew', null);
        this.lmService.propertyId = this.lmService.propIdForRightBar;
        this.lmService.contractId = null;
        this.lmService.contact_showRightBar = true;
      }, 50);
    } else if (addOrEdit == 'edit_contract') {
      if (this.isMobile == true) {
        this.router.navigate(['/contracts'], { queryParams: { id: contact?._id } });
      } else {
        let is_listing_contract = contact?.is_listing_contract === false ? false : contact?.is_listing_contract;
        if (is_listing_contract == false) {
          this.lmService.addTabInLevels(`EOI - ${contact?.lot_name}`, '', contact);
          this.lmService.contact_showRightBar = true;
        } else {
          if (this.userPermission.includes('contract.manage') || this.userPermission.includes('contract.edit') || this.userRole == 'master admin') {
            let name: any;
            this.lmService.contract_show_div = addOrEdit;
            if (contact?.buyer) {
              name = contact?.buyer[0];
            }
            let exactName = name ? name : '';
            this.lmService.addTabInLevels('Contract' + ' - ' + exactName + ' - ' + contact?.property_address, contact?._id, contact);
            this.lmService.contractId = contact?._id;
            this.lmService.propertyId = null;
          } else {
            this.toastr.error('Access denied');
          }
        }
      }
    } else if (addOrEdit == 'edit_property') {
      this.lmService.property_show_div = addOrEdit;
      this.lmService.addTabInLevels('Property' + ' - ' + contact?.property_address, contact?._id, contact);
    } else if (addOrEdit == 'add_property') {
      this.lmService.property_show_div = addOrEdit;
      this.lmService.addTabInLevels('Property', 'new');
    } else if (addOrEdit == 'edit_project') {
      this.lmService.addTabInLevels('Project' + ' - ' + contact?.Project_Name, contact?._id, contact);
      if (Crypto.decrypt(this.localStorageService.GetItem('contact_project_id'))) {
        this.localStorageService.RemoveItem('contact_project_id');
      }
      this.localStorageService.SetItem('contact_project_id', Crypto.encrypt(contact?._id));
    } else if (addOrEdit == 'add_project') {
      this.lmService.addTabInLevels('Project', 'createnew');
      this.lmService.contact_showRightBar = true;
      this.lmService.company_show_div = addOrEdit;
    } else if (addOrEdit == 'edit_contact') {
      this.lmService.isEdit_show_div = addOrEdit;
      this.lmService.contact_showRightBar = true;
      this.lmService.addTabInLevels(`Contact-${contact?.full_name}`, contact?._id, contact, {}, 'contact');
      this.selectedContact = contact;
    } else if (addOrEdit == 'add_contact') {
      if (this.insertedUserId) {
        this.lmService.contact_show_div = addOrEdit;
        this.lmService.contact_showRightBar = true;
        this.disabled_tab = true;
        this.lmService.addTabInLevels('Contact', 'new', null, {}, 'contact');
        this.UserForm.patchValue({
          role_id: this.current_role_id,
          office_id: this.api.getOfficeId(),
          user_type: 'Contact',
        });
        this.applyDefaultSubOffice();
      } else {
        this.toastr.error('Please create contact first');
      }
    }
  }

  // Closes the right bar, resets form values, and sets up the UI for a new state
  closeRightBar() {
    this.lmService.tab_levels = []; // Clear the tab levels
    this.lmService.contact_showRightBar = false; // Hide the right bar
    this.selectedContact = null; // Deselect any selected contact
    this.logos = []; // Clear any logos
    this.UserForm.reset(); // Reset the form fields
    this.UserForm.patchValue({
      role_id: this.current_role_id, // Set the current role ID
      office_id: this.api.getOfficeId(), // Set the office ID
      user_type: 'Contact', // Set the user type as "Contact"
    });
    this.applyDefaultSubOffice();
    // Remove active classes from tabs and list items
    $('.UserForm_tabs .tab-pane').removeClass('active show');
    $('.UserForm_li li a').removeClass('active');
    // Add active class to the user info tab and listing detail section
    $('#userinfo').addClass('active show');
    $('.listing_detail').addClass('active');
  }

  // Handles the selection of new images and adds them to the logos array
  onSelect(event) {
    if (this.logos == null) {
      this.logos = []; // Initialize the logos array if it's null
    }
    // Check if there are files added and loop through them
    if (event.addedFiles && event.addedFiles.length) {
      for (let i = 0; i < event.addedFiles.length; i++) {
        let logoName = event.addedFiles[i].name; // Get the name of the added file
        const fileReader: FileReader = new FileReader();
        fileReader.readAsDataURL(event.addedFiles[i]); // Convert the file to a data URL
        fileReader.onload = () => {
          // Push the file data to the logos array
          this.logos.push({ name: logoName, file: fileReader.result });
        };
      }
    }
  }

  resetContactAddress() {
    this.UserForm.patchValue({
      building_name: null,
      unit_no: null,
      street_no: null,
      street_name: null,
      suburb: null,
      state: null,
      post_code: null,
      country: null,
    });
  }

  // Handles the change in the address data and patches the relevant fields in the form
  handleAddressChange(address: any) {
    // Reset all address fields to null before updating with new address data
    this.resetContactAddress();
    // Loop through the address components to extract address details
    address?.address_components.forEach(el => {
      el.types.forEach(type => {
        // Check if the component type matches known address fields and patch the form accordingly
        if (type === 'premise') {
          this.UserForm.patchValue({
            building_name: el?.long_name,
          });
        } else if (type == 'subpremise') {
          this.UserForm.patchValue({
            unit_no: el?.long_name,
          });
        } else if (type === 'street_number') {
          this.UserForm.patchValue({
            street_no: el?.long_name,
          });
        } else if (type === 'route') {
          // Patch the street name (route)
          this.UserForm.patchValue({
            street_name: el?.long_name,
          });
        } else if (type === 'locality') {
          // Patch the suburb based on the address component and existing filtered items
          this.UserForm.patchValue({
            suburb: el?.long_name,
          });
        } else if (type === 'administrative_area_level_1') {
          // Patch the state (administrative area level 1)
          this.UserForm.patchValue({
            state: el?.short_name,
          });
        } else if (type === 'postal_code') {
          // Patch the postal code
          this.UserForm.patchValue({
            post_code: el?.short_name,
          });
        } else if (type === 'country') {
          // Patch the country name
          this.UserForm.patchValue({
            country: el?.long_name,
          });
        }
      });
    });
    // Construct a full address string from the patched address fields
    this.UserForm.patchValue({
      contact_address: address?.formatted_address,
    });
  }

  // Fetches tasks related to the contact based on the provided ID
  getTasks() {
    // Determine the ID to use: either this.id or selected_Contact_Input_id
    let id = this.id ? this.id : this.selected_Contact_Input_id;
    try {
      // Make an API call to fetch tasks related to the contact using the ID
      this.userService.getContactTasks(id).subscribe({
        next: response => {
          // Set the cache flag to true indicating that data is cached
          this.isCache = true;
          // Store the full list of tasks from the API response
          let fullListData = response.data;
          // Filter out tasks with status "Closed"
          fullListData = fullListData.filter(el => el.taskStatusName !== 'Closed');
          // If the user is not a 'master admin' and tasks are not shown for the contact, filter the tasks further
          if (this.api.getRole() != 'master admin' && !this.isShowContactTask) {
            fullListData = fullListData.filter(el => {
              // Check if the user has a role that allows them to view the task, or if they are assigned to it
              if (
                (this.contactTaskSettings && this.contactTaskSettings.viewRoles.includes(this.api.getRoleId())) ||
                el.assigns.some(agent => agent.user_id == this.api.getUserId())
              ) {
                return el;
              }
            });
            // Store the filtered tasks in fullList
            this.fullList = fullListData;
          } else {
            // If the user is a 'master admin' or tasks are shown for the contact, no filtering is applied
            this.fullList = fullListData;
          }
        },
      });
    } catch (error) {
      // Handle any errors that may occur during the API call (empty catch block)
    }
  }

  // Fetches stream data based on the provided parameters, such as page, per_page, role, etc.
  getStream(
    page = 1, // The current page number (default: 1)
    per_page = 10, // Number of records per page (default: 10)
    query = '', // Search query to filter results (default: empty string)
    bool = false // Flag to indicate if it's a pagination call (default: false)
  ) {
    // Proceed only if a valid ID is provided (not null, undefined, or 'createnew')
    if (this.id !== null && this.id != undefined && this.id != '' && this.id !== 'createnew') {
      // Make an API call to fetch stream data based on the given parameters
      this._historyService.getStreamDetailByModuleName(this.id, 'contact', page, per_page, query).subscribe({
        next: response => {
          // Set a timeout to allow time for the API response before processing the data
          window.setTimeout(() => {
            let stream = []; // Initialize an empty array to hold the stream data
            stream = response.data; // Assign the data from the API response to the stream variable
            // Set cache to true to indicate that data is cached
            this.isCache = true;
            // Sort the stream by the created date in descending order
            stream.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
            if (bool) {
              this.streams.push(...stream);
              if (stream.length < 14) {
                // If the stream contains fewer than 14 items, stop loading
                this.isLoading = false;
                this.streamRows = this.streams.length;
              } else {
                // Otherwise, add more rows to the stream
                this.streamRows += 15;
              }
            } else {
              // If 'bool' is false, reset the stream data to the new stream
              this.streamPage = 1; // Reset the stream page to 1
              this.streamRows = 15; // Reset the stream rows to 15
              this.streams = stream; // Set the streams to the new stream data
            }
            // Update the total record count from the API response
            this.totalRecord = response['meta']?.['pagination']?.['total'];
            this.isSearching = false;
          }, 1000);
          // Store the statistics from the API response, including total leads
          this.stats = {
            ...response.stats,
            totalleads: response?.stats?.totalleads?.reverse() || response?.stats?.totalleads || [],
          };
        },
        error: _ => {
          this.isSearching = false;
          this.isLoading = false;
        },
      });
    }
  }

  // Opens a confirmation dialog to ask the user if they want to remove the contact from the current contact list

  deleteAttachedContact(id) {
    this.remmiConfirm
      .delete({
        title: 'Remove Related Contact?',
        message: 'This contact will be unlinked from the current contact.',
        confirmLabel: 'Remove',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this.deleteContactNow(id);
        }
      });
  }

  // Deletes the contact by making a DELETE request to the API with the provided contact ID
  deleteContactNow(id) {
    // Send a DELETE request to remove the related contact from the contact list
    this.userService.deleteRelatedContacts(id).subscribe({
      next: response => {
        // Set isCache to false to reload data from the server after deletion
        this.isCache = false;
        // Show a success message upon successful deletion
        this.toastr.success(response?.message);
        // Refresh the list of attached contacts
        this.getAttachedContacts();
        this.getStream();
      },
    });
  }

  showName(product) {
    if (product?.first_name && product?.last_name) {
      return product?.first_name?.charAt(0) + '' + product?.last_name?.charAt(0);
    } else if (product?.full_name) {
      return product?.full_name?.charAt(0);
    }
  }
  showUserName(user) {
    if (user?.first_name && user?.last_name) {
      let name = user?.first_name + ' ' + user?.last_name;
      return name;
    } else if (user?.full_name) {
      return user?.full_name;
    }
  }

  // Handles the search functionality for contacts based on the query entered
  searchContacts(event) {
    // Reset the selected contact when starting a new search
    this.attach_contact = null;
    // Get the search query and convert it to lowercase for case-insensitive comparison
    let value = event?.query.toLowerCase();
    this.searchInput.next(value);

    if (value && this.lmService?.shortContactCompany?.length === 0) {
      this.contact_search_complete = true;
    } else {
      this.contact_search_complete = false;
    }
  }

  // Handles the selection of a contact and prepares necessary data for attachment

  contactSelection(element) {
    this.full_attach_contact = element;
    this.attach_contact = element?.name ? element.name?.trim() : '';
    !this.attach_contact ? (this.btnDisable = true) : (this.btnDisable = false);
    this.queryParams.contact_id = this.id;
    this.queryParams.related_contact_id = element?._id;
  }

  public selectedRelatedContact = null;

  // Attaches a contact either by checking if related contact is to be added or if manual selection is required
  attachContact() {
    // Prevent duplicate associations from rapid repeated clicks while a request is in flight
    if (this.isAttachingContact) {
      return;
    }
    // Check if related contact should be added
    if (this.lmService.isRelated_add === true) {
      // Prepare data for the post request to attach the contact
      let data = {
        contact_id: this.lmService.cont_id, // ID of the contact to be attached
        related_contact_id: this.insertedUserId, // ID of the related contact
        relation: [], // Relation data (empty for now)
      };
      this.isAttachingContact = true;
      // Post the request to attach the contact
      this.userService.createRelatedContacts(data).subscribe({
        next: () => {
          this.isAttachingContact = false;
          // Show success message when the contact is successfully attached
          this.toastr.success('Contact attached successfully');
        },
        error: () => {
          this.isAttachingContact = false;
        },
      });
    } else {
      // Disable the button while the action is processing
      this.btnDisable = true;

      if (this.insertedUserId) {
        // Set loading to true while the process is in progress
        this.loading = true;

        // Check if a contact is selected and if the selected contact matches the expected one
        if (!this.full_attach_contact) {
          // If no contact is selected or the name doesn't match, stop loading and show error
          this.loading = false;
          this.toastr.error('Please select contact first');
          return;
        } else {
          // Check if the contact is already attached
          let findContact = this.attached_contacts?.find(item => item?.contact?._id == this.full_attach_contact?._id);
          if (findContact) {
            // If the contact is already attached, show error and stop loading
            this.toastr.error('User is already associated to this Contact as' + ' ' + findContact?.relation);
            this.loading = false;
            return;
          } else {
            // Clear the relation data before sending the request
            this.queryParams.relation = [];
            this.isAttachingContact = true;

            // Post the request to attach the contact
            this.userService
              .createRelatedContacts({
                contact_id: this.queryParams.contact_id ? this.queryParams.contact_id : this.insertedUserId,
                related_contact_id: this.queryParams.related_contact_id, // ID of the related contact
                relation: [], // Relation data (empty for now)
              })
              .subscribe({
                next: () => {
                  // Reset states after successful attachment
                  this.selectedRelatedContact = null;
                  this.message.sendMessage({
                    isClearItems: true,
                  });
                  this.full_attach_contact = null;
                  this.attach_contact = null;
                  this.btnDisable = true;
                  this.loading = false;
                  this.isAttachingContact = false;
                  this.isCache = false;
                  this.queryParams = {};
                  // Show success message
                  this.toastr.success('Contact attached successfully');
                  // Refresh the list of attached contacts
                  this.getAttachedContacts();
                  this.getStream();
                },
                error: () => {
                  this.loading = false;
                  this.isAttachingContact = false;
                },
              });
          }
        }
      } else {
        // Show error if no contact is created
        this.toastr.error('First create contact');
      }
    }
  }

  // Fetches and assigns related contacts based on either 'id' or 'insertedUserId'
  getAttachedContacts() {
    // Initialize the attached_contacts array to ensure it is empty before fetching data
    this.attached_contacts = [];
    // Determine which ID to use (either 'id' or 'insertedUserId')
    let getAttachContact = this.id ? this.id : this.insertedUserId;
    // Call the API to get the related contacts and cache the result
    this.userService.getRelatedContacts(getAttachContact).subscribe({
      next: response => {
        // Mark the cache as true once the response is received
        this.isCache = true;
        // Assign the returned data (contacts) to the attached_contacts array
        this.attached_contacts = response?.data;
      },
    });
  }

  // Fetches the listing data from the API
  getListing() {
    // Checks if the office ID is available before making the API request
    if (this.api.getOfficeId()) {
      this.listingService.getShortListing().subscribe({
        next: response => {
          this.isCache = false; // Disables cache after fetching the data
          // Filters the response data to separate associated and non-associated properties
          this.propertiesList = response['data'].filter(x => x?.associate_property !== true); // Listings that are not associated
        },
      });
    }
  }

  // Filters the listings based on the search query entered by the user
  searchListing(event) {
    let filtered: any[] = [];
    let query = event.query;
    // Iterates through the properties list to find matching results
    for (let i = 0; i < this.propertiesList?.length; i++) {
      let item = this.propertiesList[i];
      let name = `${item?.property_address?.toLowerCase()}`;
      // Checks if the property address starts with or contains the search query
      if (name.indexOf(query.toLowerCase()) >= 0) {
        if (item?.property_address !== null) {
          filtered.push(item); // Adds the matching item to the filtered list
        }
      }
    }
    this.filteredListing = filtered; // Stores the filtered results
    // Updates the search completion status based on results
    if (this.filteredListing?.length === 0) {
      this.property_search_complete = true;
    } else {
      this.property_search_complete = false;
    }
  }

  // Handles listing selection and assigns necessary property parameters
  listingSelection(e) {
    // Disables or enables the listing button based on selection
    !this.attach_listing ? (this.listingBtnDisable = true) : (this.listingBtnDisable = false);
    // Assigns selected listing details to the property parameters
    this.property_Params.contact_id = this.id;
    this.property_Params.property_id = e?.value?._id;
  }

  // Attaches a listing to a contact
  attachListing() {
    this.loading = true; // Enables loading state
    this.listingBtnDisable = true; // Disables the listing button
    // If no listing is selected, reset loading and button states
    if (!this.attach_listing) {
      this.loading = false;
      this.listingBtnDisable = false;
      return;
    } else {
      // Checks if the listing is already attached to the contact
      let findContact = this.attached_listing?.find(item => item?._id == this.attach_listing?._id);
      if (findContact) {
        this.toastr.error('Listing is already associate to this contact');
        this.loading = false;
        return;
      }
      // Checks if the selected listing is already associated
      else if (this.attached_listing?.find(x => x?.property?._id === this.property_Params.property_id)) {
        this.toastr.error('Listing already associated');
        this.loading = false;
      }
      // Proceeds with attaching the listing if it's not already associated
      else {
        this.property_Params.type = [];
        // Sends a request to attach the listing to the contact
        this.userService.savePropertyContact(this.property_Params).subscribe({
          next: () => {
            this.attach_listing = null; // Clears the selected listing
            this.listingBtnDisable = true; // Disables the button
            this.property_Params = {}; // Resets the property parameters
            this.toastr.success('Listing attached successfully'); // Shows success message
            this.loading = false;
            this.isCache = false;
            this.getAttachedListing(); // Refreshes the attached listings
            this.getStream(); // Calls additional function to process stream data
          },
          error: error => {
            this.loading = false;
            console.error(error); // Logs the error if request fails
          },
        });
      }
    }
  }

  getTimeFormat(dateTime) {
    return moment(dateTime).format('hh:mm A');
  }

  // Fetches the attached property listings for the current contact
  getAttachedListing() {
    this.userService.getPropertyContact(this.id).subscribe({
      next: response => {
        this.isCache = true; // Enables cache after retrieving data
        this.attached_listing = []; // Clears the attached listings array
        // Filters and assigns non-associated properties that are not hidden listings
        this.attached_listing = response['data'].filter(x => x?.property?.associate_property !== true && x?.is_show_listing !== false);
        // Excludes properties with "Buyer Solicitor" or "Seller Solicitor" types
        this.attached_listing = this.attached_listing.filter(x => !x?.type.includes('Buyer Solicitor') && !x?.type.includes('Seller Solicitor'));
        // Stores attached contracts
        let no_cancelled_contract = response['contract']?.filter(el => !el?.cancelledDate);
        let cancelled_contract = response['contract']?.filter(el => el?.cancelledDate);
        this.attached_contracts = [...no_cancelled_contract, ...cancelled_contract];
      },
    });
    this.isCache = false; // Disables cache after fetching data
    this.getListingTags(true);
  }

  deleteAttachedListing(id, prop) {
    const isListing = prop === 'listing';
    this.remmiConfirm
      .delete({
        title: isListing ? 'Remove Listing?' : 'Remove Contract?',
        message: isListing ? 'This listing will be unlinked from this contact.' : 'This contract will be unlinked from this contact.',
        confirmLabel: 'Remove',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          isListing ? this.deleteListingNow(id) : this.deleteContractNow(id);
        }
      });
  }

  // Deletes the attached listing from the database
  deleteListingNow(id) {
    this.userService.deletePropertyContact(id).subscribe({
      next: () => {
        this.isCache = false; // Disables cache after deletion
        this.toastr.success('Deleted successfully');
        this.getAttachedListing(); // Refreshes the attached listing data
      },
    });
  }
  // Deletes the attached contract from the database
  deleteContractNow(id) {
    let body = {
      contract_id: id,
      contact_id: this.insertedUserId,
    };
    this._staffContactService.updateContactAssociatedWithContract(body).subscribe({
      next: () => {
        this.isCache = false; // Disables cache after deletion
        this.getAttachedListing(); // Refreshes the attached listing/contract data
        this.toastr.success('Deleted successfully');
      },
    });
  }

  // Fetches the list of properties from the API
  getProperties() {
    this.sharedService
      .getDropDownItems(`property`) // API call to fetch properties based on office ID
      .subscribe({
        next: response => {
          this.propertied = response['data']; // Stores the retrieved property data
          this.isCache = true; // Sets cache flag to true after data is loaded
        },
      });
  }

  // Searches for properties based on user input
  searchProperties(event) {
    let filtered: any[] = [];
    let query = event.query;
    // Loops through the properties list and filters based on the query
    for (let i = 0; i < this.propertied?.length; i++) {
      let item = this.propertied[i];
      let name = `${item?.property_address?.toLowerCase()}`;
      // Checks if the property address starts with or contains the query string
      if (name.indexOf(query.toLowerCase()) >= 0) {
        if (item?.property_address !== null) {
          filtered.push(item); // Adds matching properties to the filtered list
        }
      }
    }
    this.filteredProperty = filtered; // Updates the filtered properties list
    // Sets the search completion flag based on whether results are found
    if (this.filteredProperty?.length === 0) {
      this.property_search_complete = true;
    } else {
      this.property_search_complete = false;
    }
  }

  // Handles property selection event
  propertySelection(e) {
    // Enables or disables the listing button based on property selection
    !this.attach_property ? (this.listingBtnDisable = true) : (this.listingBtnDisable = false);
    // Assigns the selected property's ID to the property parameters
    this.property_Params.contact_id = this.id;
    this.property_Params.property_data_id = e?.value?._id;
  }

  // Attaches a property to the selected contact
  attachProperty() {
    this.loading = true; // Sets loading state to true
    this.listingBtnDisable = true; // Disables the listing button to prevent multiple submissions
    // Checks if `attach_property` is not selected
    if (!this.attach_property) {
      this.loading = false; // Resets loading state
      this.listingBtnDisable = false; // Enables the listing button again
      return;
    } else {
      // Checks if the property is already associated with the contact
      let findContact = this.attached_properties?.find(item => item?._id == this.attach_property?._id);
      if (findContact) {
        this.toastr.error('Property is already associated with this contact');
        this.loading = false; // Resets loading state
        return;
      }
      // Checks if the property is already associated based on property_data_id
      else if (this.attached_properties?.find(x => x?.property_data?._id === this.property_Params.property_data_id)) {
        this.toastr.error('Property already associated');
        this.loading = false; // Resets loading state
      } else {
        // Assigns contact type to the property parameters
        this.property_Params.type = this.selectedContact?.contact_type;
        // Sends a request to attach the property
        this.userService.savePropertyContact(this.property_Params).subscribe({
          next: () => {
            this.attach_property = null; // Resets selected property
            this.listingBtnDisable = true; // Disables listing button
            this.property_Params = {}; // Clears property parameters
            this.toastr.success('Property attached successfully'); // Displays success message
            this.loading = false; // Resets loading state
            this.isCache = false; // Disables cache
            this.getAttachedProperty(); // Refreshes the attached property list
            this.getStream(); // Fetches additional data related to the stream
          },
          error: error => {
            this.loading = false; // Resets loading state
            console.error(error); // Logs error for debugging
          },
        });
      }
    }
  }

  // Fetches attached properties related to the contact
  getAttachedProperty() {
    this.userService.getPropertyContact(this.id).subscribe({
      next: response => {
        this.isCache = true; // Enables cache after fetching data
        this.attached_properties = []; // Clears the existing attached properties list
        // Filters properties that should be displayed (excludes those with `is_show_listing` set to false)
        this.attached_properties = response['property_data']?.filter(x => x?.is_show_listing !== false);
        // Further filters out properties that are associated with Buyer Solicitor or Seller Solicitor
        this.attached_properties = this.attached_properties?.filter(
          x => !x?.type?.includes('Buyer Solicitor') && !x?.type?.includes('Seller Solicitor')
        );
      },
    });
    this.isCache = false; // Disables cache before calling the next function
  }

  deleteAttachedProperty(id) {
    this.remmiConfirm
      .delete({
        title: 'Remove Property?',
        message: 'This property will be unlinked from this contact.',
        confirmLabel: 'Remove',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this.deletePropertyNow(id);
        }
      });
  }

  // Deletes a property associated with a contact
  deletePropertyNow(id) {
    // Gets the contact ID, using `insertedUserId` if `id` is not available
    let conId = this.id ? this.id : this.insertedUserId;
    // Sends a delete request to remove the property from the contact
    this.userService.deletePropertyContactNow(id, conId).subscribe({
      next: () => {
        // Disables cache to ensure fresh data is fetched
        this.isCache = false;
        // Fetches the updated list of attached properties
        this.getAttachedProperty();
        // Displays a success message
        this.toastr.success('Deleted successfully');
      },
    });
  }

  // Update the user profile when the profile image changes
  updateProfileOnImageChange() {
    // If the contact address field is empty, reset related address fields to null
    if (this.UserForm.get('contact_address')?.value == '') {
      this.UserForm.patchValue({
        building_name: null,
        unit_no: null,
        street_no: null,
        street_name: null,
        suburb: null,
        state: null,
        post_code: null,
        country: null,
      });
    }
    // If the telephone number field has a value, format it based on country code
    if (this.UserForm.get('telephone_no')?.value) {
      let numb = '';
      if (this.UserForm.get('telephone_no')?.value?.countryCode == 'AU') {
        numb = this.UserForm.get('telephone_no').value?.nationalNumber; // Use national format for Australia
      } else {
        numb = this.UserForm.get('telephone_no').value?.internationalNumber; // Use international format for other countries
      }
      this.UserForm.patchValue({
        telephone_no: numb, // Update telephone number with formatted value
      });
    }
    // If the mobile number field has a value, format it based on country code
    if (this.UserForm.get('mobile_no')?.value) {
      let numb = '';
      if (this.UserForm.get('mobile_no')?.value?.countryCode == 'AU') {
        numb = this.UserForm.get('mobile_no').value?.nationalNumber; // Use national format for Australia
      } else {
        numb = this.UserForm.get('mobile_no').value?.internationalNumber; // Use international format for other countries
      }
      this.UserForm.patchValue({
        mobile_no: numb, // Update mobile number with formatted value
      });
    }
    // Set the username field to the value of the email field
    this.UserForm.patchValue({ username: this.UserForm.get('email').value });
    // Validate all form fields
    this.formHelper.validateAllFormFields(this.UserForm);
    // If the form is invalid, find all invalid fields and trigger validation
    if (!this.UserForm.valid) {
      let fields: any = Object.entries(this.UserForm.controls)
        .reduce((acc, [key, value]) => {
          if (value.status === 'INVALID') {
            // Find the corresponding error field from formAllFields list
            acc.push(this.formAllFields.find(errorfield => errorfield.name === key) || undefined);
          }
          return acc;
        }, [])
        ?.filter(error_field => error_field !== undefined && error_field !== null);
      // Validate the identified invalid fields
      fields && this.validateFieldsOnRequest(fields);
      // Reset the submitted button state
      this.submittedBtn = false;
      return;
    }
  }

  toggleCollapse(box) {
    box.isOpen = !box.isOpen;
  }
  addSpace(value) {
    return value?.replace(/,/g, ', ');
  }

  getAppointments() {
    this.userService.getContactAppointment(this.selectedContact?.email).subscribe({
      next: response => {
        response.data.forEach(x => {
          let summary = x?.summary.replace(/^Remmi:\s*/, '');
          x['final_summary'] = summary[0];
        });
        this.appointments = response.data.reverse();
      },
    });
  }

  // Function to check if a given value is a valid date
  isDate(value: any): boolean {
    return !isNaN(new Date(value).getTime());
  }

  // Function to add or edit a task
  addNewTask(task, new_or_edit) {
    // Gets the contact ID from the input or inserted user ID
    let id = this.selected_Contact_Input_id || this.insertedUserId;
    // Checks if the task is new or an existing one and adds a tab accordingly
    if (new_or_edit == true) {
      this.lmService.addTabInLevels('Task', id, null, { extra: 'Contact' });
    } else if (new_or_edit == false) {
      this.lmService.addTabInLevels('Task', task?._id, task);
    }
    // Short delay before marking the task as new and stopping the reload
    setTimeout(() => {
      this.lmService.is_new_task = true;
    }, 50);
  }

  // Creates a new lead based on existing user data
  newLead() {
    // If an inserted user ID exists, update the form
    this.insertedUserId ? this.patchEditForm() : '';

    // Waits for 1.5 seconds before opening the lead tab
    setTimeout(() => {
      this.leadTab();
    }, 1500);
  }

  // Populates and emits lead details
  leadTab() {
    // Emits the default lead information
    this.NewLeadInformation.emit({
      addDefaults: this.addDefaults,
    });
    // Sets default lead details based on the authenticated user and selected contact
    this.addDefaults.Owner = null;
    this.addDefaults.agent_responsible = this.AuthUser?._id;
    this.addDefaults.first_name = this.selectedContact?.first_name;
    this.addDefaults.last_name = this.selectedContact?.last_name;
    this.addDefaults.email = this.selectedContact?.email;
    this.addDefaults.mobile_phone = this.selectedContact?.mobile_no;
    this.addDefaults.telephone = this.selectedContact?.telephone_no;
    this.addDefaults.contactid = this.selectedContact?._id;
    this.addDefaults.lead_status = 'New';
    this.addDefaults.lead_create = 'contact';
    // Marks this as a new lead in the service
    this.lmService.is_new_lead = true;
    if (!this.isMobile) {
      // Adds a new lead tab
      this.lmService.addTabInLevels('Lead', null, null, { extra: 'Lead' });
    } else {
      // Navigate to the leads page
      this.router.navigate(['/leads'], { queryParams: { id: 'createnew' } });
    }
  }

  // Handles the drag-and-drop event for associating tags with a contact
  drop(event: CdkDragDrop<any[]>, task) {
    // If the task has existing relations, store them in contact_to_update
    if (task.relation) {
      this.contact_to_update = task.relation;
    }
    // Prevents adding duplicate tags to the same contact
    if (task?.relation?.includes(event.item.data)) {
      this.toastr.error('Tag is already associated with this contact');
      return;
    } else {
      // If the item is moved within the same container, reorder the list
      if (event.previousContainer === event.container) {
        moveItemInArray(this.contact_to_update, event.previousIndex, event.currentIndex);
      } else {
        // If the item is dragged from another container, add it as a new field
        this.addField(event.item.data, event.currentIndex, task);
      }
    }
  }

  // Adds a new field to the contact at the specified index
  addField(fieldType: string, index: number, task) {
    this.contact_to_update?.splice(index, 0, fieldType);
    this.updateTags(task);
  }

  // Updates tags related to a contact and refreshes data
  updateTags(task) {
    this.userService
      .updateContactTags(task?._id, {
        relation: this.contact_to_update,
      })
      .subscribe({
        next: response => {
          this.toastr.success(response.message);
          this.contact_to_update = [];
          this.isCache = false;
          this.getAttachedContacts();
        },
        error: error => {
          this.toastr.error(error);
        },
      });
  }

  // Removes a tag from the contact and updates the tags list
  removeTag(tag, task) {
    this.remmiConfirm
      .ask({
        title: 'Remove Tag?',
        message: 'This relation tag will be removed from the related contact.',
        subject: tag,
        confirmLabel: 'Remove',
        tone: 'warning',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this.contact_to_update = task?.relation?.filter(item => item !== tag);
          this.updateTags(task);
        }
      });
  }

  // Toggles the visibility of the password field
  public showHidePassword() {
    this.showPassword = !this.showPassword;
  }

  isSearching = false;
  // Searches streams based on input value
  searchStream(e) {
    this.isSearching = true;
    this.searchStreams.next(e.target.value);
  }

  // Edits a lead by finding it in the total leads list
  _editLead(leadId: string) {
    let lead = this.stats['totalleads'].filter(itm => {
      return leadId == itm._id;
    });
    if (lead.length > -1) this.editLead(lead.shift());
  }

  /**
   * Edits a lead by checking if the current user has permission to edit it.
   * If the user is not the assigned agent or does not have an admin role, the function returns false.
   * Otherwise, it adds the lead to the tab and updates the selected lead.
   * @param lead - The lead object to be edited.
   */

  editLead(lead) {
    if (lead.agent != this.AuthUser._id && this.AuthUser?.role !== 'Operations Manager' && this.AuthUser.role !== 'Master Admin') return false;
    if (this.isMobile == true) {
      this.router.navigate(['/leads'], { queryParams: { id: lead?._id } });
    } else if (this.api.getUserId() === lead?.agent || this.AuthUser?.role == 'Master Admin' || this.AuthUser?.role == 'Operations Manager') {
      this.lmService.addTabInLevels('Lead' + ' - ' + lead?.first_name + ' ' + lead?.last_name, lead?._id, lead, null, 'lead');
    }
  }

  /**
   * Retrieves the list of connected contacts.
   * Converts the `_id` of each attached contact into a formatted string.
   * @returns An array of formatted strings representing connected contacts.
   */
  getConnectedTo() {
    if (this.attached_contacts?.length) {
      const myArr = [...this?.attached_contacts]; // Create a copy of the attached contacts array
      const mee = myArr.map(a => 's_' + a?._id.toString()); // Format each contact ID
      return mee; // Return the formatted array
    }
  }

  /**
   * Removes the assignment of a lead.
   */
  removeAssignment(lead) {
    this.remmiConfirm
      .ask({
        title: 'Remove Assigned Lead?',
        message: 'This lead will be unlinked from this contact.',
        subject: [lead?.first_name, lead?.last_name].filter(Boolean).join(' '),
        confirmLabel: 'Remove',
        tone: 'warning',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this.removeAssignmentNow(lead);
        }
      });
  }

  private removeAssignmentNow(lead) {
    // API call to remove the assignment for the given lead
    this.leads.getAssignment(lead._id).subscribe({
      // Success callback: Refresh stream and show success message
      next: response => {
        this.getStream(); // Refreshes the stream to reflect changes
        this.toastr.success(response.message); // Displays success notification
      },
      // Error callback: Logs the error if the request fails
      error: error => {
        console.error(error);
      },
    });
  }

  // Close tag manager popup & reset tag search
  closeTagManger() {
    this.lmService.tag_manager = false;
    this.resetTagSearch();
  }

  // Resets the tag search by clearing the keyword input and restoring the original tag data.
  resetTagSearch() {
    this.keywordTags = null;
    this.tagsData = this.tagsDataCopy;
  }

  /**
   * Checks if a tag already exists in the `tagsData` or `new_tag` array before adding it.
   * - Prevents duplicate tags in the same module type.
   * - Ensures uniqueness by comparing trimmed and lowercase values.
   * - Displays error messages if the tag already exists.
   */
  pushTagToArray(e) {
    // Find the tag array corresponding to the selected module type
    let tagArr = this.tagsData.find(tagArr => tagArr.module_type == this.module_type?.name);
    if (tagArr?.data) {
      // Check if the entered tag already exists in the existing tag list
      let tag_exist = tagArr?.data?.find(tag => tag?.tag_name?.toLowerCase().trim() == e.value.toLowerCase().trim());
      let tag_in_new_tag = [];
      // Check if the tag is already present in the `new_tag` array
      if (this.new_tag?.length) {
        tag_in_new_tag = this.new_tag.filter(tag => tag?.toLowerCase().trim() == e.value.toLowerCase().trim());
      }
      if (tag_exist) {
        // Remove duplicate entry from `new_tag` array
        this.new_tag.splice(this.new_tag.indexOf(e.value.trim()), 1);
        this.toastr.error('Tag already exist'); // Show error message
      } else if (tag_in_new_tag?.length > 1) {
        this.getUnique(); // Ensure uniqueness in `new_tag`
        this.toastr.error('Tag is already entered'); // Show error message
      }
    }
  }

  /**
   * Removes duplicate values from the `new_tag` array, ensuring uniqueness.
   * The comparison is case-insensitive and trims whitespace.
   */
  getUnique() {
    var uniqueArray = []; // Initialize an empty array to store unique values
    // Loop through each value in the `new_tag` array
    for (var value of this.new_tag) {
      // Convert value to lowercase, trim whitespace, and check if it's already in `uniqueArray`
      if (uniqueArray.indexOf(value.toLowerCase().trim()) === -1) {
        uniqueArray.push(value.trim()); // Add unique value to the array
      }
    }
    this.new_tag = uniqueArray; // Update `new_tag` with the unique values
  }

  /**
   * Creates a new tag based on the selected tag type and module type.
   * If the user has the appropriate role, the tag is created directly.
   * Otherwise, a request is made for the tag creation.
   */
  createTag() {
    this.loading = true; // Set loading state to true
    let payLoad = {}; // Initialize payload object
    // Check if a tag type is selected
    if (this.tag_type) {
      // If there are multiple tags, format the payload accordingly
      if (this.new_tag?.length > 1) {
        payLoad = {
          'tag_name[]': this.new_tag, // Array of tag names
          module_id: this.contact_tag_module_id || '',
          type_id: this.tag_type, // Tag type ID
          office_id: this.api.getOfficeId(), // Office ID
          user_id: this.api.getUserId(), // User ID
        };
      } else {
        payLoad = {
          'tag_name[]': this.new_tag, // Single tag name
          module_id: this.contact_tag_module_id || '',
          type_id: this.tag_type, // Tag type ID
          office_id: this.api.getOfficeId(), // Office ID
          user_id: this.api.getUserId(), // User ID
        };
      }
      // Check if user has permission to create a tag directly
      if (this.userRole == 'master admin' || this.userRole == 'operations manager') {
        this.tagMangerService.addTag(payLoad).subscribe({
          next: response => {
            if (response?.status == true) {
              this.toastr.success('Tag successfully created'); // Show success message
              this.isCache = false; // Invalidate cache
              // Refresh tags
              this.getTags(true);
              this.new_tag = []; // Reset input fields
              this.tag_type = null;
              this.new_tag_popup = false;
              this.loading = false; // Reset loading state
            } else {
              this.toastr.error(response?.message); // Show error message
              this.loading = false;
            }
          },
          error: error => {
            this.toastr.error(error?.error?.message ? error?.error?.message : error?.message); // Show API error message
            this.loading = false;
          },
        });
      } else {
        // If the user doesn't have permission, request tag creation
        this.tagMangerService.requestTag(payLoad).subscribe({
          next: response => {
            if (response?.status == true) {
              this.toastr.success('Tag successfully created'); // Show success message
              this.new_tag = []; // Reset input fields
              this.tag_type = '';
              this.new_tag_popup = false;
            } else {
              this.toastr.error(response?.message); // Show error message
            }
            this.loading = false;
          },
          error: error => {
            this.toastr.error(error?.error?.message ? error?.error?.message : error?.message); // Show API error message
          },
        });
      }
    } else {
      this.toastr.error('Please select tag type'); // Show validation error
      this.loading = false;
    }
  }

  /**
   * Creates a new tag type by sending a payload to the API.
   * If successful, it refreshes the tag list, resets form fields, and closes the popup.
   */
  createTagType() {
    this.loading = true; // Set loading state to true
    // Prepare the payload for the API request
    let payLoad = {
      module_id: this.tagsData[0]?._id, // Get module ID from the first tag data
      type: 'tag_types', // Define the type as tag_types
      name: this.tag_type, // Set the name of the new tag type
      office_id: this.api.getOfficeId(), // Get the current office ID
      user_id: this.api.getUserId(), // Get the current user ID
    };
    // Make API request to create a new tag type
    this.tagMangerService.createTag(payLoad).subscribe({
      next: response => {
        if (response?.status == true) {
          this.toastr.success('Tag type successfully created'); // Show success message
          this.isCache = false; // Reset cache
          // Refresh the tags list
          this.getTags(true);
          // this.getSettingsTag(); // (Commented out) Potential additional refresh logic
          // Reset form fields
          this.tag_type = null;
          this.newTagTypePopUp = false; // Close the tag creation popup
          this.module_type = null;
        } else {
          this.toastr.error(response?.message); // Show error message if the API response fails
        }
        this.loading = false; // Reset loading state
      },
      error: error => {
        // Handle API error and display the error message
        this.toastr.error(error?.error?.message ? error?.error?.message : error?.message);
      },
    });
  }

  /**
   * Checks if the selected event value is "createnew" and opens the tag creation popup.
   * If "createnew" is selected, it resets the module type and tag type fields.
   */
  isNewTypeModel(event) {
    // Check if the selected event value is "createnew"
    if (event?._id == 'createnew' || event?.value == 'createnew' || event?.value?._id == 'createnew') {
      // Open the new tag type popup
      this.newTagTypePopUp = true;
      // Reset module type
      this.module_type = null;
      // Use setTimeout to reset tag_type asynchronously to prevent UI update issues
      setTimeout(() => {
        this.tag_type = null;
      });
    }
  }

  // Retrieve the list of connected listings
  getListingConnectedTo() {
    // Check if there are any attached listings
    if (this.attached_listing?.length) {
      // Create a shallow copy of the attached listings array
      const myArr = [...this?.attached_listing];
      // Map each listing's `_id` to a string prefixed with "s_"
      const mee = myArr.map(a => 's_' + a?._id.toString());
      // Return the formatted array
      return mee;
    }
  }

  // Handle drag-and-drop events for listing items
  dropListing(event: CdkDragDrop<any[]>, task) {
    // Check if the task has a 'type' property, and set 'contact_to_update' accordingly
    if (task.type) {
      this.contact_to_update = task.type;
    } else {
      this.contact_to_update = [];
    }
    // Prevent duplicate tags from being added to the contact
    if (task?.type?.includes(event.item.data)) {
      this.toastr.error('Tag is already associated with this contact');
      return;
    } else {
      // If the item is moved within the same container, reorder it
      if (event.previousContainer === event.container) {
        moveItemInArray(this.contact_to_update, event.previousIndex, event.currentIndex);
      } else {
        // If the item is dropped into a different container, add it as a new field
        this.addListingField(event.item.data, event.currentIndex, task);
      }
    }
  }

  // Add a listing field to the contact update array and trigger an update
  addListingField(fieldType: string, index: number, task) {
    // Insert the new field type at the specified index in the contact_to_update array
    this.contact_to_update?.splice(index, 0, fieldType);
    // Call the function to update listing tags after modifying the contact update array
    this.up_dateListingTags(task);
  }

  // Function to update listing tags for a specific task
  up_dateListingTags(task) {
    this.userService
      .updatePropertyContact(task?._id, {
        type: this.contact_to_update, // Sending updated contact type in the request body
      })
      .subscribe({
        next: _ => {
          // Display success message upon successful update
          this.toastr.success('Listing contact updated successfully');
          // Reset the contact update array
          this.contact_to_update = [];
          // Disable cache to ensure fresh data fetch
          this.isCache = false;
          // Refresh the attached listing, history, and stream data after update
          this.getAttachedListing();
          this.message.getModuleHistory(true);
          this.getStream(this.selectedContact);
        },
        error: error => {
          // Display an error message if the update fails
          this.toastr.error(error.error.message);
        },
      });
  }

  // Remove tag from associate listing and refresh data
  removelistingTag(tag, task) {
    this.remmiConfirm
      .ask({
        title: 'Remove Tag?',
        message: 'This tag will be removed from the linked listing.',
        subject: tag,
        confirmLabel: 'Remove',
        tone: 'warning',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this.contact_to_update = task?.type?.filter(item => item !== tag);
          this.up_dateListingTags(task);
        }
      });
  }

  // Handle the drag-and-drop event for tags
  dropTag(event: CdkDragDrop<string[]>) {
    // Check if the item is moved within the same container
    if (event.previousContainer === event.container) {
      // Reorder the item within the same list
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      // Add the dragged tag to the form at the new position
      this.addTagInForm(event.currentIndex, event.item.data);
    }
  }

  // Add or remove a tag in the form
  addTagInForm(index, data) {
    // Check if the tag already exists in the list
    let findInd = this.todo.find(el => el?._id == data?._id);
    if (!findInd) {
      // If the tag doesn't exist, add it at the specified index
      this.todo?.splice(index, 0, data);
    } else {
      // If the tag already exists, remove it from the list
      let removeIndex = this.todo.findIndex(el => el?._id == data?._id);
      this.todo?.splice(removeIndex, 1);
    }
  }

  // Remove Tag
  removePublicTag(i) {
    this.todo?.splice(i, 1);
  }

  noTagsFound: boolean = false;
  // Filter tags based on the provided keyword
  filterTags() {
    // Create a deep copy of the original tags data to avoid modifying the original dataset
    this.tagsData = JSON.parse(JSON.stringify(this.tagsDataCopy));
    // Check if there is a keyword entered for filtering
    if (this.keywordTags) {
      // Iterate through each tag group
      this.tagsData.map(tagArr => {
        // Iterate through each type within the tag group
        tagArr?.types?.map(type => {
          // Check if the type name includes the keyword
          if (type?.name?.toLowerCase()?.includes(this.keywordTags.toLowerCase())) {
            return type;
          } else {
            // Filter the tags inside the type that match the keyword
            type.data = type?.data?.filter(tag => tag?.tag_name?.toLowerCase().includes(this.keywordTags.toLowerCase()));
            return type;
          }
        });
        // Filter the tags at the group level that match the keyword
        tagArr.data = tagArr?.data?.filter(tag => tag?.tag_name?.toLowerCase().includes(this.keywordTags.toLowerCase()));
        return tagArr;
      });
      // Remove empty types (those without matching tags) from the final data
      this.tagsData.map(result => {
        result.types = result.types.filter(course => course?.data?.length);
        return result;
      });
      this.noTagsFound = this.tagsData.every(group => !group.types || group.types.length === 0);
    }
  }

  // Function to handle tab selection events
  handleTabs(e) {
    // Check if the event corresponds to 'clickView'
    if (e == 'clickView') {
      // Enable the tag manager when 'clickView' is selected
      this.lmService.tag_manager = true;
    } else {
      // Disable the tag manager for other tab selections
      this.lmService.tag_manager = false;
    }
  }

  // Duplicate a lead record
  duplicateRecords(lead) {
    this.leads.duplicateLead(lead._id, {}).subscribe({
      next: () => {
        // Show success notification when the duplication is successful
        this.toastr.success('Duplicated');
        // Reset cache to ensure updated data is fetched
        this.isCache = false;
        // Refresh the lead stream to reflect the changes
        this.getStream();
      },
      error: () => {
        // Show an error notification if something goes wrong
        this.toastr.error('Something has gone wrong');
      },
    });
  }

  // Fetch and process listing workflow processes
  GetListingWorkflowProcesses() {
    // Mark the workflow process tab as opened
    this._workflowService.isWorkflowProcessTabOpened = true;

    // Clear the active process list before fetching new data
    this._workflowService.ActiveProcessList = [];

    // Store the current record ID for processing
    this._workflowService.processRecordId = this.id;

    // Fetch all processes related to the 'Contact' module for the current record ID
    this._workflowService
      .GetAllProcessesByModule(this.id, this._workflowService.module_array.filter(res => res.name === 'Contact')?.[0]?.module_value)
      .subscribe({
        next: response => {
          try {
            // Destructure response object
            const { status, data, meta } = response;

            // Check if the API call was successful
            if (status) {
              // Process and filter the workflow data
              this._workflowService.ActiveProcessList = data
                ?.map(
                  result =>
                    (result = {
                      ...result,
                      module: Utils.capitalizePhrase(result?.module?.split('_')?.join(' ')?.trim() || ''),
                    })
                )
                ?.filter(result =>
                  result?.[`filter`].some(
                    value =>
                      (value?._id === this.id && value?.process?.toLowerCase() !== 'stop') ||
                      (value?._id === 'all' && value?.process?.toLowerCase() !== 'stop')
                  )
                );

              // Update pagination details based on the fetched data
              this._workflowService.centralizedProcessPagination = {
                ...this._workflowService.centralizedProcessPagination,
                per_page: 10,
                total_pages: Math.ceil(meta?.pagination?.total / 10),
                total: meta?.pagination?.total,
                numberOfRecords: this._workflowService.ActiveProcessList?.length > 10 ? 10 : this._workflowService.ActiveProcessList?.length,
              };
            } else {
              // If response status is false, clear the active process list
              this._workflowService.ActiveProcessList = [];
            }
          } catch (error) {
            // Handle any unexpected errors by clearing the active process list
            this._workflowService.ActiveProcessList = [];
          }
        },
      });
  }

  // Handle changes in the right panel based on the selected event type
  onChangeRightPanel(event) {
    if (event === 'Tasks') {
      // Ensure that an inserted user ID exists before proceeding
      if (this.insertedUserId) {
        // Disable cache for fresh data retrieval
        this.isCache = false;
        this.getTasks();
      }
    }
    // Check if the event type is 'property'
    else if (event === 'Related Property') {
      // Ensure that an inserted user ID exists before proceeding
      if (this.insertedUserId) {
        // Disable cache for fresh data retrieval
        this.isCache = false;
        // Fetch property-related data including listings and attached properties
        this.getListing();
        this.getProperties();
        this.getAttachedListing();
        this.getAttachedProperty();
        this.getListingTags(true);
      }
    } else if (event === 'Associations') {
      if (this.insertedUserId) {
        this.GetAssociatedProjects();
        // Fetch project list if eligible
        if (this.GetAssociatedProjectEligibleStatus()) {
          this.lmService.GetProjectList();
        }
      }
    }
    // Check if the event type is 'appointment'
    else if (event === 'Appointments') {
      if (this.insertedUserId) {
        this.getAppointments();
      }
    }
    // Check if the event type is 'contact'
    else if (event === 'Related Contacts') {
      // Ensure that an inserted user ID exists before proceeding
      if (this.insertedUserId) {
        this.lmService.getContactRelations(); // Fetch contact relations
        // Fetch attached contacts related to the user
        this.getAttachedContacts();
        this.getListingTags(true);
      }
    } else if (event === 'History') {
      if (this.insertedUserId) {
        this.historyList = [];
        this.message.getModuleHistory(true);
      }
    }
  }

  // Update the contact address field when the building name changes
  buildingNameChanged() {
    // Check if the building name field is not empty or null
    if (this.UserForm.controls['building_name'].value != '' && this.UserForm.controls['building_name'].value != null) {
      // Construct the address string including building name
      let new_address = `"${this.UserForm.get('building_name').value}" ${
        this.UserForm.get('unit_no').value ? this.UserForm.get('unit_no').value : ''
      } ${this.UserForm.get('street_no').value ? this.UserForm.get('street_no').value : ''} ${
        this.UserForm.get('street_name').value ? this.UserForm.get('street_name').value : ''
      } ${this.UserForm.get('suburb').value?.suburb ? this.UserForm.get('suburb').value?.suburb : ''} ${
        this.UserForm.get('state').value ? this.UserForm.get('state').value : ''
      } ${this.UserForm.get('post_code').value ? this.UserForm.get('post_code').value : ''} ${
        this.UserForm.get('country').value ? this.UserForm.get('country').value : ''
      }`;

      // Trim extra spaces from the generated address string
      let addr = new_address.trim();

      // Update the contact_address field in the form
      this.UserForm.patchValue({
        contact_address: addr,
      });
    } else {
      // Construct the address string without building name if it is empty
      let new_address = `${this.UserForm.get('building_name').value ? this.UserForm.get('building_name').value : ''} ${
        this.UserForm.get('unit_no').value ? this.UserForm.get('unit_no').value : ''
      } ${this.UserForm.get('street_no').value ? this.UserForm.get('street_no').value : ''} ${
        this.UserForm.get('street_name').value ? this.UserForm.get('street_name').value : ''
      } ${this.UserForm.get('suburb').value?.suburb ? this.UserForm.get('suburb').value?.suburb : ''} ${
        this.UserForm.get('state').value ? this.UserForm.get('state').value : ''
      } ${this.UserForm.get('post_code').value ? this.UserForm.get('post_code').value : ''} ${
        this.UserForm.get('country').value ? this.UserForm.get('country').value : ''
      }`;

      // Trim extra spaces from the generated address string
      let addr = new_address.trim();

      // Update the contact_address field in the form
      this.UserForm.patchValue({ contact_address: addr });
    }
  }

  // Select an item and update the active index
  selectItem(item: any) {
    this.selectedItem = item; // Set the selected item
    this.rightActiveIndex = item.panel; // Update the active index
    this.showMenu = false; // Hide the menu after selection
    this.onChangeRightPanel(item.label);
  }

  // Function to parse a date string into a Date object
  parseDate(dateString: string): Date | null {
    if (!dateString) return null; // Return null if the input date string is empty
    const isoDate = new Date(dateString); // Try parsing as an ISO date
    if (!isNaN(isoDate.getTime())) {
      // Check if the parsed date is valid
      return isoDate;
    }
    // Attempt to parse the date string in the format 'DD/MM/YYYY'
    const [day, month, year] = dateString.split('/');
    if (day && month && year) {
      return new Date(Number(year), Number(month) - 1, Number(day)); // Convert and return the date
    }
    return null; // Return null if the date string format is invalid
  }

  // Fetch email templates for the current office
  getEmailTemplate() {
    this.sharedService
      .getEmailTemplate() // API call to get email templates
      .subscribe({
        next: response => {
          this.emailTemplates = response.data; // Store the response data in `emailTemplates`
          this.emailTemplates = this.emailTemplates.filter(x => x.type == 'contacts'); // Filter templates by type 'contacts'
          this.emailTempSelected = this.emailTemplates[0]; // Select the first template
          this.emailTempSelectedId = this.emailTempSelected?._id; // Store the selected template ID
          this.getTemplateBody(); // Call the function to format the email template
        },
      });
  }

  // Function to retrieve and format the email template body and subject
  getTemplateBody() {
    // Find the selected email template based on the selected template ID
    let searchEmail = this.emailTemplates.filter(x => x._id == this.emailTempSelectedId);
    if (searchEmail && searchEmail.length > 0) {
      this.emailTempSelected = searchEmail[0]; // Store the selected template
    }

    let body;
    let subject;
    body = this.emailTempSelected.body; // Extract email body from the selected template
    subject = this.emailTempSelected.subject; // Extract email subject from the selected template

    const regex = /{([^}]+)}/g; // Regular expression to find placeholders in the template
    const matchesBody = body.match(regex); // Find placeholders in the body
    const matchesSubject = subject.match(regex); // Find placeholders in the subject

    let selectedBody = body;
    let selectedSubject = subject;

    // Replace placeholders in the body with corresponding values from `selectedContact`
    if (matchesBody) {
      matchesBody.forEach(match => {
        const propertyName = match.substring(1, match.length - 1); // Extract the placeholder name
        const propertyValue = this.selectedContact[propertyName]; // Get the value from selectedContact
        selectedBody = selectedBody.replace(match, propertyValue); // Replace placeholder with value
      });
      this.emailBody = selectedBody; // Assign the formatted body to `emailBody`
    }

    // Replace placeholders in the subject with corresponding values from the form
    if (matchesSubject) {
      matchesSubject.forEach(match => {
        const propertyName = match.substring(1, match.length - 1); // Extract the placeholder name
        const propertyValue = this.UserForm.get(propertyName).value; // Get the value from form control
        selectedSubject = selectedSubject.replace(match, propertyValue); // Replace placeholder with value
      });
      this.emailSubject = selectedSubject; // Assign the formatted subject to `emailSubject`
    } else {
      this.emailSubject = subject; // If no placeholders, keep the original subject
    }
  }

  // Send an email to the user
  sendEmail() {
    this.userService
      .sendEmailToUser({
        to: this.emailTo, // Recipient's email address
        subject: this.emailSubject, // Email subject
        body: this.emailBody, // Email body content
      })
      .subscribe({
        next: response => {
          if (response.status == true) {
            this.toastr.success('Email sent successfully'); // Show success message
            this.email_modal = false; // Close the email modal
          } else {
            this.toastr.error(response.message); // Show error message if sending fails
          }
        },
      });
  }

  // Checks if the user has an eligible role for associated projects
  GetAssociatedProjectEligibleStatus(): boolean {
    // Retrieve the user's role from local storage
    let role = Crypto.decrypt(this.localStorageService.GetItem('role'));
    // Return true if the role is either "Master Admin" or "Operations Manager"
    return ['master admin', 'operations manager'].includes(role?.toLocaleLowerCase());
  }

  // Fetches the list of projects associated with the selected contact
  GetAssociatedProjects() {
    // API call to retrieve associated project details for the selected user
    this.userService.getAssociatedProjects(this.insertedUserId).subscribe({
      next: (response: any) => {
        const { status, data }: { status: boolean; data: any[] } = response; // Extract status and data from response
        if (status && data?.length > 0) {
          // If response is successful and contains data, map the projects and set Project_Name
          this.AssociatedProjectsUsers = data?.map((project: any) => ({
            ...project,
            Project_Name: project?.project?.Project_Name || '',
          }));
        } else {
          // If no data is returned, set AssociatedProjectsUsers to an empty array
          this.AssociatedProjectsUsers = [];
        }
      },
    });
  }

  // Associates or removes a user from a project based on the specified action
  AssociateUserToProject(action: 'add' | 'remove', project: any[]) {
    if (action === 'add') {
      this.runProjectAssociation(action, project);
      return;
    }
    if (!project?.length) {
      return;
    }
    this.remmiConfirm
      .delete({
        title: 'Remove From Project?',
        message: 'This contact will no longer be associated with the selected project.',
        subject: project.length === 1 ? project[0]?.Project_Name : `${project.length} projects selected`,
        confirmLabel: 'Remove',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this.runProjectAssociation(action, project);
        }
      });
  }

  private runProjectAssociation(action: 'add' | 'remove', project: any[]) {
    let promise_list: Observable<any>[] = []; // List to store API requests

    if (action === 'add') {
      // Loop through projects and push API post requests for association
      project.forEach((pro: any) => {
        promise_list.push(
          this.userService.associateUserToProject({
            projectid: pro?._id ? pro?._id : pro,
            user_id: this.insertedUserId,
          })
        );
      });
    } else {
      // Loop through projects and push API delete requests for removal
      project.forEach((pro: any) => {
        promise_list.push(
          this.userService.deletedAssociateUserToProject({
            projectid: pro?.projectid ? pro?.projectid : pro,
            user_id: this.insertedUserId,
          })
        );
      });
    }
    if (promise_list?.length > 0) {
      // Execute all API calls in parallel using forkJoin and properly handle deprecations
      forkJoin([...promise_list]).subscribe({
        next: () => {
          this.toastr.success(`${action === 'add' ? 'Added successfully' : 'Removed successfully'}`);
          this.GetAssociatedProjects(); // Refresh associated projects
          this.isCache = false; // Clear cache flag
          this.message.getModuleHistory(true); // Fetch updated history
          this.message.sendMessage({
            isClearItems: true,
          });
          this.AssociatedProjectSelection = this.AddNewProject = []; // Reset selections
        },
        error: () => {
          this.toastr.error(`Something went wrong`);
        },
      });
    }
  }

  // Validates the specified fields in the UserForm and collects error messages if validation fails
  validateFieldsOnRequest(fields: any[] = []) {
    if (fields?.length > 0) {
      // Loop through each field and set 'required' validation
      fields?.forEach(field_error => {
        this.UserForm?.controls?.[field_error?.name]?.setValidators([Validators.required]);
        this.UserForm?.controls?.[field_error?.name]?.updateValueAndValidity();
      });

      // Reset the error messages and count of invalid fields
      this.numOfNotValidFields = this.requiredErrorMessages.length = 0;

      // Iterate through the form controls to check for validation errors
      for (let prop in this.UserForm.controls) {
        if (this.UserForm.controls[prop].errors) {
          // Create an error object with the field name and label message
          let fieldReqObj = {
            field: prop,
            message: `${fields?.find(textfield => textfield.name === prop)?.label || ''}`,
          };
          this.requiredErrorMessages.push(fieldReqObj); // Store error message
          this.numOfNotValidFields++; // Increment invalid fields count
        }
      }
    }
  }

  // Activates the tab index based on the error message and scrolls to the relevant form field
  ActivateTabIndexByError(message: any) {
    let space_serrated: string[] = message?.split(' '); // Splitting the message into words
    if (space_serrated?.[0]?.trim()?.length > 0) {
      let setTimOutTimer: number = 0; // Variable to store timeout delay
      let marketInfoTab: string[] = ['gender', 'birthday']; // List of fields related to the market info tab

      // Check if the first word in the message matches a predefined field and set the tab index
      if (marketInfoTab?.some(value => value === space_serrated?.[0]?.trim())) {
        this.rightActiveIndex = 1; // Setting active tab index
        setTimOutTimer = 500; // Setting delay for scrolling
      }
      setTimeout(() => {
        // Finding the form element by formControlName, name, or id
        const element = this.formElementRef.nativeElement.querySelector(`[formControlName="${space_serrated?.[0]?.trim()}"]`)
          ? this.formElementRef.nativeElement.querySelector(`[formControlName="${space_serrated?.[0]?.trim()}"]`)
          : this.formElementRef.nativeElement.querySelector(`[name="${space_serrated?.[0]?.trim()}"]`)
            ? this.formElementRef.nativeElement.querySelector(`[name="${space_serrated?.[0]?.trim()}"]`)
            : this.formElementRef.nativeElement.querySelector(`[id="${space_serrated?.[0]?.trim()}"]`);

        // If the element exists, scroll it into view smoothly
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, setTimOutTimer);
    }
  }

  // ------------ SideBar Contact Pagination -------------------------------

  contactRows: number = 10;
  contactScrollTop: number = 0;
  @ViewChild('contactScrollableElement') contactScrollableElement!: ElementRef;
  scrollContactToTop(): void {
    const element = this.contactScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onContactScroll(event: Event): void {
    const element = event.target;
    this.contactScrollTop = element['scrollTop'];
  }

  // ------------ SideBar Streams Pagination -------------------------------

  streamRows: number = 15;
  streamPage: number = 1;
  isLoading: boolean = true;
  scrollTop: number = 0;
  @ViewChild('streamScrollableElement') streamScrollableElement!: ElementRef;
  streamScrollToTop(): void {
    const element = this.streamScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onStreamScroll(event: Event): void {
    const element = event.target;
    this.scrollTop = element['scrollTop'];
    let a: any = element['scrollHeight'] - element['scrollTop'];
    let b: any = element['scrollHeight'] - element['scrollTop'];
    let c = element['clientHeight'];

    if ((parseInt(a) - 5 < parseInt(c) || parseInt(b) == parseInt(c)) && this.isLoading) {
      this.streamPage = this.streamPage + 1;
      this.isLoading = false;
      this.getStream(this.streamPage, 15, this.keyword, true);
    }
  }

  // ------------- SideBar Leads Pagination ------------------------------

  sideLeadRows: number = 10;
  sideLeadScrollTop: number = 0;
  @ViewChild('sideLeadScrollableElement') sideLeadScrollableElement!: ElementRef;
  sideLeadScrollToTop(): void {
    const element = this.sideLeadScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onsideLeadScroll(event: Event): void {
    const element = event.target;
    this.sideLeadScrollTop = element['scrollTop'];
  }

  // ------------- SideBar Task Pagination ------------------------------

  sideTaskRows: number = 10;
  sideTaskScrollTop: number = 0;
  @ViewChild('sideLeadScrollableElement') sideTaskScrollableElement!: ElementRef;
  sideTaskScrollToTop(): void {
    const element = this.sideTaskScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onsideTaskScroll(event: Event): void {
    const element = event.target;
    this.sideTaskScrollTop = element['scrollTop'];
  }

  // ------------- SideBar Listing Pagination ------------------------------

  sideListingRows: number = 10;
  sideListingScrollTop: number = 0;
  @ViewChild('sideListingScrollableElement') sideListingScrollableElement!: ElementRef;
  sideListingScrollToTop(): void {
    const element = this.sideListingScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onsideListingScroll(event: Event): void {
    const element = event.target;
    this.sideListingScrollTop = element['scrollTop'];
  }

  // ------------- SideBar Property Pagination ------------------------------

  sidePropertyRows: number = 10;
  sidePropertyScrollTop: number = 0;
  @ViewChild('sidePropertyScrollableElement') sidePropertyScrollableElement!: ElementRef;
  sidePropertyScrollToTop(): void {
    const element = this.sidePropertyScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onsidePropertyScroll(event: Event): void {
    const element = event.target;
    this.sidePropertyScrollTop = element['scrollTop'];
  }

  // ------------- SideBar Project Pagination ------------------------------

  sideProjectRows: number = 10;
  sideProjectScrollTop: number = 0;
  @ViewChild('sideProjectScrollableElement') sideProjectScrollableElement!: ElementRef;
  sideProjectScrollToTop(): void {
    const element = this.sideProjectScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onsideProjectScroll(event: Event): void {
    const element = event.target;
    this.sideProjectScrollTop = element['scrollTop'];
  }

  // ------------- SideBar Contract Pagination ------------------------------

  sideContractRows: number = 10;
  sideContractScrollTop: number = 0;
  @ViewChild('sideContractScrollableElement') sideContractScrollableElement!: ElementRef;
  sideContractScrollToTop(): void {
    const element = this.sideContractScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onsideContractScroll(event: Event): void {
    const element = event.target;
    this.sideContractScrollTop = element['scrollTop'];
  }

  // ------------- SideBar Related Contacts Pagination ------------------------------

  sideRelatedContactRows: number = 10;
  relatedContactScrollTop: number = 0;
  @ViewChild('relatedContactScrollableElement') relatedContactScrollableElement!: ElementRef;
  relatedContactScrollToTop(): void {
    const element = this.relatedContactScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onRelatedContactScroll(event: Event): void {
    const element = event.target;
    this.relatedContactScrollTop = element['scrollTop'];
  }

  // ------------ SideBar Association Pagination -------------------------------

  ascScrollTop: number = 0;
  previousScrollTop = 0;
  page: number = 1;
  total_contact: any;
  @ViewChild('scrollableElement') scrollableElement!: ElementRef;
  scrollToTop(): void {
    const element = this.scrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onScroll(event: Event): void {
    const element = event.target as HTMLElement;
    this.ascScrollTop = element.scrollTop;
  }

  types_by_module = [];
  contactListingType: any[] = [];
  contact_tag_module_id: any;
  getTags(isCache = false) {
    // this.loadTag = false
    this.contactType = [];
    this.contactListingType = [];
    this.preferred_contact_method = [];
    this.companyType = [];
    this.companyRole = [];
    this.addTile = [];
    // this.contactRelatedTag = [];
    this.redux.getTags(this.api.getOfficeId(), isCache, 'contact').subscribe({
      next: res => {
        this.isCache = true;
        this.tagsData = JSON.parse(JSON.stringify(res?.data));
        this.contact_tag_module_id = res?.data[0]?._id;
        this.tagsDataCopy = JSON.parse(JSON.stringify(res?.data));
        this.tagsData.forEach(element => {
          this.types_by_module = element.types;
          this.types_by_module.forEach(tag => {
            if (tag?.slug === 'type') {
            }
            if (tag?.slug === 'contact-type') {
              this.contactType = tag?.data?.sort((a, b) => a?.tag_name.localeCompare(b?.tag_name));
            }
            if (tag?.slug === 'contact-listing-type') {
              this.contactListingType = tag?.data?.sort((a, b) => a?.tag_name.localeCompare(b?.tag_name));
            }
            if (tag?.slug === 'preferred-contact-method') {
              this.preferred_contact_method = tag?.data?.sort((a, b) => a?.tag_name.localeCompare(b?.tag_name));
            }
            if (tag?.slug === 'company-contact-type') {
              this.companyType = tag?.data?.sort((a, b) => a?.tag_name.localeCompare(b?.tag_name));
            }
            if (tag?.slug === 'company-role') {
              this.companyRole = tag?.data?.sort((a, b) => a?.tag_name.localeCompare(b?.tag_name));
            }
            if (tag?.slug === 'title') {
              this.addTile = tag?.data?.sort((a, b) => a?.tag_name.localeCompare(b?.tag_name));
            }
          });
        });
        let isExits = this.types_by_module.find(x => x?._id === 'createnew');
        if (!isExits) {
          this.types_by_module.push({ name: '+ Create New', _id: 'createnew' });
        }
      },
      error: error => {
        this.toastr.error(error?.message);
      },
    });
  }

  getListingTags(isCache = false) {
    this.redux.getTags(this.api.getOfficeId(), isCache, 'listing').subscribe({
      next: res => {
        this.isCache = true;
        let tagData = JSON.parse(JSON.stringify(res?.data));
        this.relatedContactTags = [];
        tagData.forEach(element => {
          this.types_by_module = element.types;
          this.types_by_module.forEach(tag => {
            if (tag?.slug == 'related-contact') {
              this.relatedContactTags = tag?.data.sort((a, b) => a?.tag_name.localeCompare(b?.tag_name));
            }
          });
        });
      },
      error: error => {
        this.toastr.error(error?.message);
      },
    });
  }

  onRContactSort(event: any): void {
    const sortField = event.field;
    const sortOrder = event.order;

    this.attached_contacts.sort((a: any, b: any) => {
      let valueA, valueB;

      if (sortField === 'relation') {
        // relation is directly on the root object, and is an array of strings
        valueA = (a['relation'] || [])[0] || '';
        valueB = (b['relation'] || [])[0] || '';
      } else if (sortField === 'company_name') {
        // companies is an array of strings inside contact
        valueA = (a.contact?.companies || []).join(', ');
        valueB = (b.contact?.companies || []).join(', ');
      } else {
        valueA = a.contact?.[sortField] || '';
        valueB = b.contact?.[sortField] || '';
      }

      // Basic string comparison
      let result = 0;
      if (valueA < valueB) result = -1;
      if (valueA > valueB) result = 1;

      return sortOrder * result;
    });
  }

  onCancelTagDialog() {
    this.module_type = null;
    this.new_tag = [];
    this.tag_type = null;
    this.new_tag_popup = false;

    // ✅ Clear internal input field
    const inputEl = this.chipsRef.nativeElement.querySelector('input');
    if (inputEl) inputEl.value = '';
  }
}
